

// import React, { useState, useEffect, useRef, useMemo } from "react";
// import axios from "axios";
// import { Link } from "react-router-dom";
// import { useLoader } from '../../../../context/LoaderProvider.jsx';
// import {
//     getVendorDetails,
//     updateVendorDetails,
//     getAllEnquiries,
//     approveVendor,
//     verifyVendorStatus
// } from "../../../Servicefile/clientManagementService.jsx";

// // Add this helper function at the top (outside component)
// const normalizeImageUrl = (url) => {
//     if (!url || url === "N/A" || typeof url !== 'string') return null;

//     // If it's already a full URL, return as is
//     if (url.startsWith('http')) {
//         return url;
//     }

//     // Remove leading slash if present and prepend base URL
//     const cleanUrl = url.replace(/^\//, '');
//     // Use the correct image server URL brandName
//     return `http://img.maamaas.com:8080/${cleanUrl}`;
// };

// const getDefaultClientDetailsRows = () => [
//     { key: "Owner Name", value: "", isUpload: false },
//     { key: "Business Plan", value: "", isUpload: false },
//     { key: "Position", value: "", isUpload: false },
//     { key: "Branding", value: "", isUpload: false },
//     { key: "Company Name", value: "", isUpload: false },
//     { key: "Register Documents", value: "", isUpload: true },
//     { key: "Phone No", value: "", isUpload: false },
//     { key: "Email ID", value: "", isUpload: false },
//     {
//         key: "Bank Details",
//         value: {
//             holderName: "",
//             branchName: "",
//             accountNumber: "",
//             ifscCode: "",
//         },
//         isUpload: false,
//     },
//     { key: "Passbook", value: "", isUpload: true },
//     { key: "AADHAR CARD NO", value: "", isUpload: false },
//     { key: "PAN CARD NO", value: "", isUpload: false },
//     { key: "Website", value: "", isUpload: false },
//     { key: "GST No.", value: "", isUpload: false },
// ];

// const STATUS_FIELD_MAP = {
//     "Owner Name": "ownerNameStatus",
//     "Business Plan": "businessPlanStatus",
//     "Company Name": "registeredNameStatus",
//     "Register Documents": "registeredDocumentsStatus",
//     "Phone No": "mobileNumberStatus",
//     "Email ID": "emailStatus",
//     "AADHAR CARD NO": "aadharNumberStatus",
//     "PAN CARD NO": "panCardStatus",
//     "Website": "websiteNameStatus",
//     "GST No.": "gstNumberStatus",
//     "Trade License": "tradeLicenseStatus",
//     "FSSI License": "fssaiLicenseStatus",
//     "Labour License": "labourLicenseStatus",
//     "Bank Details": "blankChequeStatus",
//     "Passbook": "passbookStatus",
//     "Address": "addressStatus",
//     "Order Type": "orderTypeStatus",
//     "Business Vertical": "businessVerticalStatus",
//     "Rating": "ratingStatus",
//     "Trade License Number": "tradeLicenseStatus",
//     "FSSAI License Number": "fssaiLicenseStatus",
//     "Labour License Number": "labourLicenseStatus",
// };

// // Order Type options
// const orderTypeOptions = [
//     "DINE_IN",
//     "TAKEAWAY",
//     "DELIVERY",
//     "TABLE_DINE_IN"
// ];

// // Business Plan options
// const businessPlanOptions = [
//     "HOTEL",
//     "RESTAURANT",
//     "CAFE",
//     "CLOUD_KITCHEN",
//     "FOOD_COURT",
//     "STREET_FOOD",
//     "BAKERY"
// ];

// // Business Vertical options
// const businessVerticalOptions = [
//     "FOOD_AND_BEVERAGES",
//     "CATERINGS_SERVICES",
//     "LOGISTICS_SUPPLY",
//     "FRESH_GROCERIES"
// ];

// // Rating options
// const ratingOptions = [
//     { value: 0, label: "0 - Not Rated" },
//     { value: 1, label: "1 ★" },
//     { value: 1.5, label: "1.5 ★" },
//     { value: 2, label: "2 ★" },
//     { value: 2.5, label: "2.5 ★" },
//     { value: 3, label: "3 ★" },
//     { value: 3.5, label: "3.5 ★" },
//     { value: 4, label: "4 ★" },
//     { value: 4.5, label: "4.5 ★" },
//     { value: 5, label: "5 ★" }
// ];

// // Safe date conversion utility
// const safeDateToISOString = (dateString) => {
//     if (!dateString || dateString === "N/A" || dateString === "Invalid Date") return "";

//     const date = new Date(dateString);
//     if (isNaN(date.getTime())) return "";

//     return date.toISOString().split("T")[0];
// };

// // Safe date display utility
// const safeDateDisplay = (dateString) => {
//     if (!dateString || dateString === "N/A" || dateString === "Invalid Date") return "N/A";

//     const date = new Date(dateString);
//     if (isNaN(date.getTime())) return "N/A";

//     return date.toLocaleDateString();
// };

// // Updated hasValidData function
// const hasValidData = (row, vendorDetails) => {
//     if (!row) return false;

//     const field = row.key;
//     const value = row.value;

//     // Special case for empty arrays
//     if (Array.isArray(value)) {
//         return value.length > 0 && value[0] !== "N/A";
//     }

//     // Check if the value exists and is not empty/"N/A"
//     if (typeof value === 'string') {
//         return value && value !== "N/A" && value.trim() !== "";
//     }

//     if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
//         // For Address, Bank Details, License objects
//         if (field === "Address" || field === "Bank Details" ||
//             field === "Trade License" || field === "FSSI License" || field === "Labour License") {
//             // Check if any property has valid data
//             return Object.values(value).some(val =>
//                 val && val !== "N/A" && val.toString().trim() !== ""
//             );
//         }
//         // For other objects, just check if it's not empty
//         return Object.keys(value).length > 0;
//     }

//     // For numbers (like rating)
//     if (typeof value === 'number') {
//         return value !== undefined && value !== null;
//     }

//     // For fields that are just text labels (like "Registered Documents", "Passbook Image")
//     if (value === "Registered Documents" || value === "Passbook Image") {
//         // Check if there are images for these fields
//         const hasImages = row.images && row.images.length > 0;
//         return hasImages;
//     }

//     return false;
// };

// // Updated isFieldVerified function
// const isFieldVerified = (rowKey, rowValue, vendorDetails, rowImages) => {
//     const normalisedKey = rowKey.trim().replace(/\.$/, "");
//     const statusField = STATUS_FIELD_MAP[normalisedKey];

//     // If there's a status field in the backend, check its value
//     if (statusField && vendorDetails && vendorDetails[statusField] !== undefined) {
//         return vendorDetails[statusField] === true;
//     }

//     // Create a row object to pass to hasValidData all the required data has been not changed in the real time coding
//     const rowForValidation = { key: rowKey, value: rowValue, images: rowImages };

//     // Always auto-verify these specific fields if they have data various functinalities of the code also 
//     const alwaysAutoVerifyFields = [
//         "Business Vertical",
//         "Order Type",
//         "Address",
//         "Rating",
//         "Business Plan",
//         "Position",
//         "BrandName",
//         "Website",
//         "Phone No",
//         "Email ID",
//         "GST No.",
//         "Trade License Number",
//         "FSSAI License Number",
//         "Labour License Number",
//         "Owner Name",
//         "Company Name",
//         "AADHAR CARD NO",
//         "PAN CARD NO"
//     ];

//     if (alwaysAutoVerifyFields.includes(rowKey)) {
//         return hasValidData(rowForValidation, vendorDetails);
//     }

//     // For document/image fields, check both data and images
//     const documentFields = [
//         "Register Documents",
//         "Trade License",
//         "FSSI License",
//         "Labour License",
//         "Bank Details",
//         "Passbook"
//     ];

//     if (documentFields.includes(rowKey)) {
//         // For document fields, require images
//         const hasImages = rowImages && rowImages.length > 0;
//         return hasImages;
//     }

//     return false;
// };

// const isFieldRejected = (rowKey, vendorDetails) => {
//     const normalisedKey = rowKey.trim().replace(/\.$/, "");
//     const statusField = STATUS_FIELD_MAP[normalisedKey];

//     if (!statusField || !vendorDetails) return false;

//     return vendorDetails[statusField] === false;
// };

// // New function to check if a field can be verified
// const canVerifyField = (rowKey, rowValue, vendorDetails, rowImages) => {
//     // Check if there's valid data
//     return hasValidData({ key: rowKey, value: rowValue, images: rowImages }, vendorDetails);
// };

// /* ---------------- component ---------------- */
// const FoodPaidClents = () => {
//     /* -------- list‑screen state -------- */
//     const [rolesData, setRolesData] = useState([]);
//     const [screenWidth, setScreenWidth] = useState(window.innerWidth);
//     const { showLoader, hideLoader } = useLoader();

//     // Filter states
//     const [searchType, setSearchType] = useState("vendorId");
//     const [searchQuery, setSearchQuery] = useState("");
//     const [cityFilter, setCityFilter] = useState("");
//     const [businessVerticalFilter, setBusinessVerticalFilter] = useState("");
//     const [filteredData, setFilteredData] = useState([]);

//     /* -------- detail‑screen state -------- */
//     const [selectedClient, setSelectedClient] = useState(null);
//     const [vendorDetails, setVendorDetails] = useState(null);
//     const [vendorNotFound, setVendorNotFound] = useState(false);
//     const [vendorError, setVendorError] = useState(null);
//     const [loading, setLoading] = useState(false);

//     const [rows, setRows] = useState(getDefaultClientDetailsRows());
//     const [verifiedRows, setVerifiedRows] = useState([]);
//     const [rejectedRows, setRejectedRows] = useState([]);
//     const [isApproved, setIsApproved] = useState(false);
//     const [imageLoadErrors, setImageLoadErrors] = useState(new Set());

//     const fileInputRef = useRef(null);
//     const [vendorData, setVendorData] = useState({});
//     const [rowId, setRowId] = useState(null);

//     // Screen resize effect
//     useEffect(() => {
//         const handleResize = () => setScreenWidth(window.innerWidth);
//         window.addEventListener("resize", handleResize);
//         return () => window.removeEventListener("resize", handleResize);
//     }, []);

//     const getCurrentVendorId = () => {
//         return (
//             selectedClient?.vendorId ||
//             selectedClient?.vendorEnquiry?.vendorId ||
//             vendorDetails?.vendorId ||
//             null
//         );
//     };
//     const handleApproveAll = async () => {
//         try {
//             const token = localStorage.getItem("authToken");
//             const vendorId = getCurrentVendorId();

//             if (!vendorId) return alert("Vendor ID not found ❌");

//             const body = {
//                 approvalStatus: true,
//                 approvalRemarks: "Approved by admin"
//             };

//             const data = await approveVendor(vendorId, body, token);

//             console.log("API Response:", data);

//             alert("Vendor Approved Successfully ✅");

//             fetchVendorDetails(vendorId);

//         } catch (error) {
//             console.error("Approval Error:", error);
//             alert("Approval Failed ❌");
//         }
//     };
//     const vendorId = getCurrentVendorId();

//     const handleImageError = (imageUrl, fieldName, index) => {
//         const errorKey = `${fieldName}-${index}`;
//         setImageLoadErrors(prev => new Set([...prev, errorKey]));
//     };

//     const handleImageLoad = (imageUrl, fieldName, index) => {
//         const errorKey = `${fieldName}-${index}`;
//         setImageLoadErrors(prev => {
//             const newSet = new Set(prev);
//             newSet.delete(errorKey);
//             return newSet;
//         });
//     };

//     const isImageFailed = (fieldName, index) => {
//         return imageLoadErrors.has(`${fieldName}-${index}`);
//     };

//     const fetchVendorDetails =
//         async (vendorId) => {

//             if (!vendorId) return;

//             setLoading(true);

//             setVendorNotFound(false);

//             setVendorError(null);

//             const token =
//                 localStorage.getItem(
//                     "authToken"
//                 );

//             try {

//                 // 🔥 SERVICE API CALL
//                 const data =
//                     await getVendorDetails(
//                         vendorId,
//                         token
//                     );

//                 setVendorDetails(data);

//                 setVendorNotFound(false);

//                 setVendorError(null);

//             } catch (err) {

//                 console.error(
//                     "❌ get-vendor-details error:",
//                     err
//                 );

//                 // 🔥 HANDLE VENDOR NOT FOUND
//                 if (
//                     err.response?.status === 500 &&
//                     err.response?.data?.message ===
//                     "vendorId not found"
//                 ) {

//                     setVendorNotFound(true);

//                     setVendorDetails(null);

//                     setVendorError(
//                         "Vendor not registered"
//                     );

//                 } else {

//                     setVendorError(
//                         "Failed to fetch vendor details"
//                     );
//                 }

//             } finally {

//                 setLoading(false);
//             }
//         };

//     const formatDate = (date) => {
//         if (!date) return "—";

//         const d = new Date(date);

//         if (isNaN(d.getTime())) return "—";

//         const day = String(d.getDate()).padStart(2, "0");
//         const month = String(d.getMonth() + 1).padStart(2, "0");
//         const year = d.getFullYear();

//         return `${day}-${month}-${year}`;
//     };

//     const handleSaveRow = async (rowIndex) => {
//         const token =
//             localStorage.getItem("authToken") ||
//             localStorage.getItem("token");

//         if (!token) {
//             alert("No authentication token found");
//             return;
//         }

//         try {
//             const vendorId = getCurrentVendorId();

//             if (!vendorId) {
//                 alert("Vendor ID not found");
//                 return;
//             }

//             const row = rows[rowIndex];

//             const formData = new FormData();
//             const vendorData = {};

//             const fieldMapping = {
//                 "Owner Name": "ownerName",
//                 "Phone No": "mobileNumber",
//                 "Position": "position",
//                 "Branding": "brandName",
//                 "Website": "websiteName",
//                 "Email ID": "email",
//                 "Company Name": "registeredName",
//                 "AADHAR CARD NO": "aadharNumber",
//                 "PAN CARD NO": "panCardNumber",
//                 "GST No.": "gstNumber",
//                 "Order Type": "orderTypes",
//                 "Business Plan": "businessPlan",
//                 "Trade License Number": "tradeLicenseNumber",
//                 "FSSAI License Number": "fssaiLicenseNumber",
//                 "Labour License Number": "labourLicenseNumber",
//                 "Rating": "rating"
//             };

//             const backendFieldName = fieldMapping[row.key];

//             // Basic Fields
//             if (backendFieldName && row.value) {

//                 if (row.key === "Order Type") {
//                     vendorData[backendFieldName] = Array.isArray(row.value)
//                         ? row.value
//                         : [row.value];
//                 }
//                 else if (row.key === "Rating") {
//                     vendorData[backendFieldName] =
//                         parseFloat(row.value) || 0;
//                 }
//                 else if (row.value !== "N/A") {
//                     vendorData[backendFieldName] = row.value;
//                 }
//             }

//             // Address
//             if (
//                 row.key === "Address" &&
//                 typeof row.value === "object"
//             ) {
//                 vendorData.doorNumber = row.value.doorNo || "";
//                 vendorData.addressLine = row.value.street || "";
//                 vendorData.city = row.value.city || "";
//                 vendorData.state = row.value.state || "";
//                 vendorData.pincode = row.value.pincode || "";
//                 vendorData.landMark = row.value.landmark || "";
//                 vendorData.latitude =
//                     row.value.latitude
//                         ? parseFloat(row.value.latitude)
//                         : null;
//                 vendorData.longitude =
//                     row.value.longitude
//                         ? parseFloat(row.value.longitude)
//                         : null;
//             }

//             // Bank Details
//             if (
//                 row.key === "Bank Details" &&
//                 typeof row.value === "object"
//             ) {
//                 vendorData.holderName =
//                     row.value.holderName || "";

//                 vendorData.branchName =
//                     row.value.branchName || "";

//                 vendorData.accountNumber =
//                     row.value.accountNumber || "";

//                 vendorData.ifscCode =
//                     row.value.ifscCode || "";
//             }

//             // Trade License
//             if (
//                 row.key === "Trade License" &&
//                 typeof row.value === "object"
//             ) {
//                 vendorData.tradeLicenseStartDate =
//                     row.value.startDate || "";

//                 vendorData.tradeLicenseEndDate =
//                     row.value.endDate || "";
//             }

//             // FSSAI License
//             if (
//                 row.key === "FSSI License" &&
//                 typeof row.value === "object"
//             ) {
//                 vendorData.fssaiStartDate =
//                     row.value.startDate || "";

//                 vendorData.fssaiEndDate =
//                     row.value.endDate || "";
//             }

//             // Labour License
//             if (
//                 row.key === "Labour License" &&
//                 typeof row.value === "object"
//             ) {
//                 vendorData.labourStartDate =
//                     row.value.startDate || "";

//                 vendorData.labourEndDate =
//                     row.value.endDate || "";
//             }

//             // Append JSON
//             formData.append(
//                 "vendorData",
//                 new Blob(
//                     [JSON.stringify(vendorData)],
//                     {
//                         type: "application/json"
//                     }
//                 )
//             );

//             // Append Images
//             if (row.images?.length > 0) {
//                 row.images.forEach((img, idx) => {

//                     if (img.file) {

//                         const imageFieldName =
//                             getImageFieldName(
//                                 row.key,
//                                 idx
//                             );

//                         formData.append(
//                             imageFieldName,
//                             img.file
//                         );
//                     }
//                 });
//             }

//             // ==========================
//             // DEBUG LOGS
//             // ==========================

//             console.log("Vendor ID:", vendorId);

//             console.log(
//                 "Vendor Data JSON:",
//                 vendorData
//             );

//             for (let pair of formData.entries()) {
//                 console.log(
//                     "FORM DATA =>",
//                     pair[0],
//                     pair[1]
//                 );
//             }

//             // API CALL
//             const response =
//                 await updateVendorDetails(
//                     vendorId,
//                     formData,
//                     token
//                 );

//             console.log(
//                 "Update Response:",
//                 response
//             );

//             alert(
//                 "Data updated successfully!"
//             );

//             setRows((prev) =>
//                 prev.map((r, idx) =>
//                     idx === rowIndex
//                         ? {
//                             ...r,
//                             isEditing: false
//                         }
//                         : r
//                 )
//             );

//             await fetchVendorDetails(vendorId);

//         } catch (err) {

//             console.error(
//                 "Full Update Error:",
//                 err
//             );

//             console.log(
//                 "Status:",
//                 err.response?.status
//             );

//             console.log(
//                 "Response Data:",
//                 err.response?.data
//             );

//             console.log(
//                 "Response Headers:",
//                 err.response?.headers
//             );

//             alert(
//                 err.response?.data?.message ||
//                 err.message ||
//                 "Failed to update vendor"
//             );
//         }
//     };

//     const getImageFieldName = (rowKey, imageIndex) => {
//         const fieldMap = {
//             "Register Documents": imageIndex === 0 ? "registeredDocumentsFront" : "registeredDocumentsBack",
//             "AADHAR CARD NO": imageIndex === 0 ? "aadharPhotoFront" : "aadharPhotoBack",
//             "PAN CARD NO": "panCard",
//             "Trade License": "tradeLicense",
//             "FSSI License": "fssaiLicense",
//             "Labour License": "labourLicense",
//             "Bank Details": "blankCheque",
//             "Passbook": "passbook",
//             "Company Name": "companyLogo",
//         };

//         return fieldMap[rowKey] || `image${imageIndex + 1}`;
//     };

//     const handleVerifyy =
//         async (i) => {

//             const normalisedKey =
//                 rows[i].key
//                     .trim()
//                     .replace(/\.$/, "");

//             const statusField =
//                 STATUS_FIELD_MAP[
//                 normalisedKey
//                 ];

//             if (!statusField) {

//                 console.warn(
//                     "No status mapping for:",
//                     rows[i].key
//                 );

//                 return;
//             }

//             const vendorId =
//                 getCurrentVendorId();

//             if (!vendorId) {

//                 alert(
//                     "Vendor ID is missing"
//                 );

//                 return;
//             }

//             // VENDOR NOT FOUND
//             if (vendorNotFound) {

//                 alert(
//                     "Vendor not registered. Cannot verify."
//                 );

//                 return;
//             }

//             const token =
//                 localStorage.getItem(
//                     "authToken"
//                 );

//             if (!token) {

//                 alert(
//                     "Authorization token missing"
//                 );

//                 return;
//             }

//             try {

//                 // ====================================
//                 // CREATE VENDOR DATA
//                 // ====================================

//                 const vendorData = {

//                     ownerNameStatus:
//                         vendorDetails
//                             ?.ownerNameStatus ??
//                         false,

//                     businessPlanStatus:
//                         vendorDetails
//                             ?.businessPlanStatus ??
//                         false,

//                     registeredNameStatus:
//                         vendorDetails
//                             ?.registeredNameStatus ??
//                         false,

//                     registeredDocumentsStatus:
//                         vendorDetails
//                             ?.registeredDocumentsStatus ??
//                         false,

//                     mobileNumberStatus:
//                         vendorDetails
//                             ?.mobileNumberStatus ??
//                         false,

//                     emailStatus:
//                         vendorDetails
//                             ?.emailStatus ??
//                         false,

//                     aadharNumberStatus:
//                         vendorDetails
//                             ?.aadharNumberStatus ??
//                         false,

//                     panCardStatus:
//                         vendorDetails
//                             ?.panCardStatus ??
//                         false,

//                     websiteNameStatus:
//                         vendorDetails
//                             ?.websiteNameStatus ??
//                         false,

//                     gstNumberStatus:
//                         vendorDetails
//                             ?.gstNumberStatus ??
//                         false,

//                     tradeLicenseStatus:
//                         vendorDetails
//                             ?.tradeLicenseStatus ??
//                         false,

//                     fssaiLicenseStatus:
//                         vendorDetails
//                             ?.fssaiLicenseStatus ??
//                         false,

//                     labourLicenseStatus:
//                         vendorDetails
//                             ?.labourLicenseStatus ??
//                         false,

//                     blankChequeStatus:
//                         vendorDetails
//                             ?.blankChequeStatus ??
//                         false,

//                     passbookStatus:
//                         vendorDetails
//                             ?.passbookStatus ??
//                         false,

//                     addressStatus:
//                         vendorDetails
//                             ?.addressStatus ??
//                         false,

//                     orderTypeStatus:
//                         vendorDetails
//                             ?.orderTypeStatus ??
//                         false,

//                     businessVerticalStatus:
//                         vendorDetails
//                             ?.businessVerticalStatus ??
//                         false,

//                     ratingStatus:
//                         vendorDetails
//                             ?.ratingStatus ??
//                         false,

//                     // UPDATE CURRENT STATUS
//                     [statusField]: true,
//                 };

//                 // ====================================
//                 // UPDATE UI IMMEDIATELY
//                 // ====================================

//                 setVendorDetails(
//                     (prev) => ({
//                         ...prev,

//                         [statusField]:
//                             true,
//                     })
//                 );

//                 // ====================================
//                 // 🔥 SERVICE API CALL
//                 // ====================================

//                 await verifyVendorStatus(
//                     vendorId,
//                     vendorData,
//                     token
//                 );

//                 // REFRESH DATA
//                 await fetchVendorDetails(
//                     vendorId
//                 );

//                 alert(
//                     "Vendor data verified successfully!"
//                 );

//             } catch (err) {

//                 console.error(
//                     "❌ Verify error:",
//                     err
//                 );

//                 // REVERT UI
//                 setVendorDetails(
//                     (prev) => ({
//                         ...prev,

//                         [statusField]:
//                             false,
//                     })
//                 );

//                 if (
//                     err.response?.status ===
//                     500 &&
//                     err.response?.data
//                         ?.message ===
//                     "vendorId not found"
//                 ) {

//                     alert(
//                         "Vendor not registered. Cannot verify."
//                     );

//                 } else if (
//                     err.response?.status ===
//                     404
//                 ) {

//                     alert(
//                         "Vendor not registered. Cannot verify."
//                     );

//                 } else {

//                     alert(
//                         `Failed to update status: ${err.response?.data
//                             ?.message ||
//                         err.message
//                         }`
//                     );
//                 }
//             }
//         };

//     const handleReject =
//         async (i) => {

//             const normalisedKey =
//                 rows[i].key
//                     .trim()
//                     .replace(/\.$/, "");

//             const statusField =
//                 STATUS_FIELD_MAP[
//                 normalisedKey
//                 ];

//             if (!statusField) {

//                 console.warn(
//                     "No status mapping for:",
//                     rows[i].key
//                 );

//                 return;
//             }

//             const vendorId =
//                 getCurrentVendorId();

//             if (!vendorId) {

//                 alert(
//                     "Vendor ID is missing – cannot update."
//                 );

//                 return;
//             }

//             // VENDOR NOT FOUND
//             if (vendorNotFound) {

//                 alert(
//                     "Vendor not registered. Cannot reject."
//                 );

//                 return;
//             }

//             const token =
//                 localStorage.getItem(
//                     "authToken"
//                 );

//             if (!token) {

//                 alert(
//                     "Authorization token missing. Please log in."
//                 );

//                 return;
//             }

//             try {

//                 // ====================================
//                 // CREATE VENDOR DATA
//                 // ====================================

//                 const vendorData = {

//                     ownerNameStatus:
//                         vendorDetails
//                             ?.ownerNameStatus ??
//                         false,

//                     businessPlanStatus:
//                         vendorDetails
//                             ?.businessPlanStatus ??
//                         false,

//                     registeredNameStatus:
//                         vendorDetails
//                             ?.registeredNameStatus ??
//                         false,

//                     registeredDocumentsStatus:
//                         vendorDetails
//                             ?.registeredDocumentsStatus ??
//                         false,

//                     mobileNumberStatus:
//                         vendorDetails
//                             ?.mobileNumberStatus ??
//                         false,

//                     emailStatus:
//                         vendorDetails
//                             ?.emailStatus ??
//                         false,

//                     aadharNumberStatus:
//                         vendorDetails
//                             ?.aadharNumberStatus ??
//                         false,

//                     panCardStatus:
//                         vendorDetails
//                             ?.panCardStatus ??
//                         false,

//                     websiteNameStatus:
//                         vendorDetails
//                             ?.websiteNameStatus ??
//                         false,

//                     gstNumberStatus:
//                         vendorDetails
//                             ?.gstNumberStatus ??
//                         false,

//                     tradeLicenseStatus:
//                         vendorDetails
//                             ?.tradeLicenseStatus ??
//                         false,

//                     fssaiLicenseStatus:
//                         vendorDetails
//                             ?.fssaiLicenseStatus ??
//                         false,

//                     labourLicenseStatus:
//                         vendorDetails
//                             ?.labourLicenseStatus ??
//                         false,

//                     blankChequeStatus:
//                         vendorDetails
//                             ?.blankChequeStatus ??
//                         false,

//                     passbookStatus:
//                         vendorDetails
//                             ?.passbookStatus ??
//                         false,

//                     addressStatus:
//                         vendorDetails
//                             ?.addressStatus ??
//                         false,

//                     orderTypeStatus:
//                         vendorDetails
//                             ?.orderTypeStatus ??
//                         false,

//                     businessVerticalStatus:
//                         vendorDetails
//                             ?.businessVerticalStatus ??
//                         false,

//                     ratingStatus:
//                         vendorDetails
//                             ?.ratingStatus ??
//                         false,

//                     // 🔥 REJECT STATUS
//                     [statusField]: false,
//                 };

//                 // ====================================
//                 // UPDATE UI IMMEDIATELY
//                 // ====================================

//                 setVendorDetails(
//                     (prev) => ({
//                         ...prev,

//                         [statusField]:
//                             false,
//                     })
//                 );

//                 // ====================================
//                 // 🔥 SERVICE API CALL
//                 // ====================================

//                 await verifyVendorStatus(
//                     vendorId,
//                     vendorData,
//                     token
//                 );

//                 // REFRESH DATA
//                 await fetchVendorDetails(
//                     vendorId
//                 );

//                 alert(
//                     "Vendor status rejected successfully!"
//                 );

//             } catch (err) {

//                 console.error(
//                     "❌ Reject error:",
//                     err
//                 );

//                 // REVERT UI
//                 setVendorDetails(
//                     (prev) => ({
//                         ...prev,

//                         [statusField]:
//                             true,
//                     })
//                 );

//                 if (
//                     err.response?.status ===
//                     500 &&
//                     err.response?.data
//                         ?.message ===
//                     "vendorId not found"
//                 ) {

//                     alert(
//                         "Vendor not registered. Cannot reject."
//                     );

//                 } else if (
//                     err.response?.status ===
//                     404
//                 ) {

//                     alert(
//                         "Vendor not registered. Cannot reject."
//                     );

//                 } else {

//                     alert(
//                         `Failed to reject status: ${err.response?.data
//                             ?.message ||
//                         err.message
//                         }`
//                     );
//                 }
//             }
//         };

//     // Fetch subscriptions from new API endpoint
//     useEffect(() => {

//         const token = localStorage.getItem("authToken");

//         const fetchData = async () => {

//             showLoader();

//             try {

//                 const data = await getAllEnquiries(token);

//                 console.log("API Response:", data);

//                 const subscriptions = Array.isArray(data)
//                     ? data
//                     : [];

//                 // Filter FOOD_AND_BEVERAGES vendors/employees
//                 const filtered = subscriptions.filter(
//                     (item) =>
//                         item.businessVerticals &&
//                         item.businessVerticals.includes("FOOD_AND_BEVERAGES") &&
//                         (
//                             item.parentId === null ||
//                             item.parentId === 0 ||
//                             item.parentId === undefined
//                         )
//                 );

//                 console.log("Filtered Data:", filtered);

//                 setRolesData(filtered);
//                 setFilteredData(filtered);

//                 if (filtered.length > 0) {

//                     const vendor = filtered[0];

//                     const vendorId = vendor?.vendorId;
//                     const parentId = vendor?.parentId;

//                     // Only fetch when parentId is null/0
//                     if (
//                         vendorId &&
//                         (
//                             parentId === null ||
//                             parentId === 0 ||
//                             parentId === undefined
//                         )
//                     ) {
//                         fetchVendorDetails(vendorId);
//                     } else {
//                         console.log(
//                             "parentId exists, API call skipped:",
//                             parentId
//                         );
//                     }
//                 }

//             } catch (err) {

//                 console.error(
//                     "Payment fetch error:",
//                     err
//                 );

//             } finally {

//                 hideLoader();
//             }
//         };

//         fetchData();

//     }, []);

//     // Apply filters
//     useEffect(() => {
//         let result = rolesData;

//         // Apply city filter
//         if (cityFilter) {
//             result = result.filter(item => item.city === cityFilter);
//         }

//         // Apply business vertical filter
//         if (businessVerticalFilter) {
//             result = result.filter(item => item.businessVertical === businessVerticalFilter);
//         }

//         // Apply search query
//         if (searchQuery.trim()) {
//             const query = searchQuery.toLowerCase().trim();
//             result = result.filter(item => {
//                 // Get the field value based on searchType
//                 let fieldValue;

//                 // Handle different field names in the subscription data
//                 if (searchType === "vendorId") {
//                     fieldValue = item.vendorId;
//                 } else if (searchType === "phoneNumber") {
//                     fieldValue = item.customerMobile;
//                 } else if (searchType === "email") {
//                     fieldValue = item.email || item.customerEmail;
//                 } else if (searchType === "name") {
//                     fieldValue = item.customerName;
//                 } else if (searchType === "city") {
//                     fieldValue = item.city;
//                 } else if (searchType === "businessVertical") {
//                     fieldValue = item.businessVertical;
//                 } else {
//                     fieldValue = item[searchType];
//                 }

//                 if (!fieldValue) return false;

//                 // For phone number search, clean non-digits
//                 if (searchType === "phoneNumber") {
//                     const cleanPartnerMobile = fieldValue.toString().replace(/\D/g, '');
//                     const cleanQuery = query.replace(/\D/g, '');
//                     return fieldValue.toString().toLowerCase().includes(query) ||
//                         cleanPartnerMobile.includes(cleanQuery);
//                 }

//                 // For other fields
//                 return fieldValue.toString().toLowerCase().includes(query);
//             });
//         }

//         setFilteredData(result);
//     }, [rolesData, cityFilter, businessVerticalFilter, searchType, searchQuery]);

//     // Get unique values for filter dropdowns
//     const uniqueCities = useMemo(() => {
//         const cities = rolesData.map(item => item.city).filter(Boolean);
//         return [...new Set(cities)].sort();
//     }, [rolesData]);

//     const uniqueBusinessVerticals = useMemo(() => {
//         const verticals = rolesData.map(item => item.businessVertical).filter(Boolean);
//         return [...new Set(verticals)].sort();
//     }, [rolesData]);

//     // Clear all filters
//     const clearAllFilters = () => {
//         setSearchQuery("");
//         setCityFilter("");
//         setBusinessVerticalFilter("");
//         setSearchType("vendorId");
//     };

//     // Get placeholder text based on search type
//     const getPlaceholderText = () => {
//         switch (searchType) {
//             case "vendorId": return "Search Vendor ID";
//             case "name": return "Search Customer Name";
//             case "email": return "Search Email";
//             case "phoneNumber": return "Search Mobile Number";
//             case "city": return "Search City";
//             case "businessVertical": return "Search Business Vertical";
//             default: return "Search...";
//         }
//     };

//     // Search options - Added businessVertical
//     const searchOptions = [
//         { value: "vendorId", label: "Vendor ID" },
//         { value: "name", label: "Customer Name" },
//         { value: "createdAt", label: "Date" },
//         { value: "email", label: "Email" },
//         { value: "phoneNumber", label: "Mobile Number" },
//         { value: "city", label: "City" },
//         { value: "businessVertical", label: "Business Vertical" }
//     ];

//     useEffect(() => {
//         if (!selectedClient) {
//             setRows(getDefaultClientDetailsRows());
//             setVerifiedRows([]);
//             setRejectedRows([]);
//             setIsApproved(false);
//             setImageLoadErrors(new Set());
//             return;
//         }

//         const merged = { ...selectedClient, ...(vendorDetails || {}) };

//         // REQUIRED Image mapping only - using normalizeImageUrl
//         const imageMap = {
//             "Register Documents": [
//                 normalizeImageUrl(merged.registeredDocumentsFront),
//                 normalizeImageUrl(merged.registeredDocumentsBack)
//             ].filter(url => url),
//             "AADHAR CARD NO": [
//                 normalizeImageUrl(merged.aadharPhotoFront),
//                 normalizeImageUrl(merged.aadharPhotoBack)
//             ].filter(url => url),
//             "PAN CARD NO": [normalizeImageUrl(merged.panCard)].filter(url => url),
//             "Trade License": [normalizeImageUrl(merged.tradeLicense)].filter(url => url),
//             "FSSI License": [normalizeImageUrl(merged.fssaiLicense)].filter(url => url),
//             "Labour License": [normalizeImageUrl(merged.labourLicense)].filter(url => url),
//             "Bank Details": [normalizeImageUrl(merged.blankCheque)].filter(url => url),
//             "Passbook": [normalizeImageUrl(merged.passbook)].filter(url => url),
//             "Company Name": [normalizeImageUrl(merged.companyLogo)].filter(url => url),
//         };

//         const newRows = [
//             { key: "Owner Name", value: merged.ownerName || "N/A" },
//             { key: "Company Name", value: merged.registeredName || "N/A" },
//             { key: "Business Plan", value: merged.businessPlan || "N/A" },
//             { key: "Position", value: merged.position || "N/A" },
//             { key: "Branding", value: merged.brandName || "N/A" },
//             { key: "Business Vertical", value: merged.businessVertical || "N/A" },

//             {
//                 key: "Order Type",
//                 value: Array.isArray(merged.orderTypes)
//                     ? merged.orderTypes
//                     : typeof merged.orderTypes === "string" && merged.orderTypes !== "N/A"
//                         ? merged.orderTypes.split(",").map(v => v.trim())
//                         : [],
//             },

//             { key: "Website", value: merged.websiteName || "N/A" },
//             { key: "Phone No", value: merged.mobileNumber || merged.customerMobile || "N/A" },
//             { key: "Email ID", value: merged.email || merged.customerEmail || "N/A" },
//             { key: "City", value: merged.city || "N/A" },

//             {
//                 key: "Address",
//                 value: {
//                     doorNo: merged.doorNumber || "N/A",
//                     street: merged.addressLine || "N/A",
//                     city: merged.city || "N/A",
//                     state: merged.state || "N/A",
//                     pincode: merged.pincode || "N/A",
//                     landmark: merged.landMark || "N/A",
//                     latitude: merged.latitude?.toString() || "N/A",
//                     longitude: merged.longitude?.toString() || "N/A",
//                 },
//             },

//             { key: "Register Documents", value: "Registered Documents" },
//             { key: "AADHAR CARD NO", value: merged.aadharNumber || "N/A" },
//             { key: "PAN CARD NO", value: merged.panCardNumber || "N/A" },

//             // Trade License Number
//             { key: "Trade License Number", value: merged.tradeLicenseNumber || "N/A" },
//             {
//                 key: "Trade License",
//                 value: {
//                     startDate: merged.tradeLicenseStartDate || "N/A",
//                     endDate: merged.tradeLicenseEndDate || "N/A",
//                 },
//             },

//             // FSSAI License Number
//             { key: "FSSAI License Number", value: merged.fssaiLicenseNumber || "N/A" },
//             {
//                 key: "FSSI License",
//                 value: {
//                     startDate: merged.fssaiStartDate || "N/A",
//                     endDate: merged.fssaiEndDate || "N/A",
//                 },
//             },

//             // Labour License Number
//             { key: "Labour License Number", value: merged.labourLicenseNumber || "N/A" },
//             {
//                 key: "Labour License",
//                 value: {
//                     startDate: merged.labourStartDate || "N/A",
//                     endDate: merged.labourEndDate || "N/A",
//                 },
//             },

//             { key: "GST No.", value: merged.gstNumber || "N/A" },

//             {
//                 key: "Bank Details",
//                 value: {
//                     holderName: merged.holderName || merged.accountHolderName || "N/A",
//                     branchName: merged.branchName || merged.bankName || "N/A",
//                     accountNumber: merged.accountNumber || merged.accountNo || "N/A",
//                     ifscCode: merged.ifscCode || "N/A",
//                 },
//             },

//             { key: "Passbook", value: "Passbook Image" },

//             // Rating field added after Passbook
//             { key: "Rating", value: merged.rating || 0 },

//             // Only keep Selected Modules and Remaining Days from subscription data
//             { key: "Selected Modules", value: merged.selectedModules?.join(", ") || "N/A" },
//             { key: "Remaining Days", value: merged.remainingDays ? `${merged.remainingDays} days` : "N/A" },
//         ];

//         const updatedRows = newRows.map((row) => ({
//             ...row,
//             images: imageMap[row.key] || [],
//         }));

//         setRows(updatedRows.map((r) => ({ ...r, isEditing: false })));
//         setVerifiedRows([]);
//         setRejectedRows([]);
//         setIsApproved(false);
//         setImageLoadErrors(new Set());
//     }, [selectedClient, vendorDetails]);

//     const handleViewClick = (client) => {
//         setSelectedClient(client);
//         const vendorId = client?.vendorId;
//         setVendorNotFound(false);
//         setVendorError(null);
//         fetchVendorDetails(vendorId);
//     };

//     const handleBackClick = () => {
//         setSelectedClient(null);
//         setVendorNotFound(false);
//         setVendorError(null);
//     };

//     const handleFileChange = (e, index) => {
//         const fileName = e.target.files[0]?.name || "";
//         const updated = [...rows];
//         updated[index].value = fileName;
//         setRows(updated);
//     };

//     // Clean Image Display Component with "-" for missing images
//     const ImageDisplay = ({ images, fieldName }) => {
//         if (!images || images.length === 0) {
//             return (
//                 <div className="text-center">
//                     <span style={{ fontSize: "18px", color: "#6c757d" }}>-</span>
//                 </div>
//             );
//         }

//         return (
//             <div className="d-flex justify-content-center gap-2 flex-wrap">
//                 {images.map((img, idx) => {
//                     const imageUrl = typeof img === 'string' ? img : img.url;
//                     const hasFailed = isImageFailed(fieldName, idx);

//                     if (hasFailed || !imageUrl) {
//                         return (
//                             <div key={idx} className="text-center">
//                                 <span style={{ fontSize: "18px", color: "#6c757d" }}>-</span>
//                             </div>
//                         );
//                     }

//                     return (
//                         <div key={idx} className="text-center position-relative">
//                             <img
//                                 src={imageUrl}
//                                 alt={`${fieldName}-${idx}`}
//                                 style={{
//                                     width: fieldName === "Company Name" ? "80px" : "60px",
//                                     height: fieldName === "Company Name" ? "80px" : "60px",
//                                     borderRadius: "6px",
//                                     objectFit: "cover",
//                                     border: "1px solid #dee2e6",
//                                 }}
//                                 onError={() => handleImageError(imageUrl, fieldName, idx)}
//                                 onLoad={() => handleImageLoad(imageUrl, fieldName, idx)}
//                             />
//                         </div>
//                     );
//                 })}
//             </div>
//         );
//     };

//     return (
//         <div className="container-fluid">
//             <div className="row">
//                 <div className="col-lg-12" style={{ marginTop: "10px" }}>
//                     <div className="client" style={{ overflowY: "auto", height: "450px" }}>
//                         {!selectedClient ? (
//                             <>
//                                 {/* Filter Controls */}
//                                 <div className="row g-2 mb-3 align-items-center me-0">
//                                     {/* Search Type Dropdown and Search Input */}
//                                     {/* Various sections of the particular data not */}

//                                     <div className="col-md-auto col-12">
//                                         <div className="d-flex align-items-center" style={{ gap: '10px' }}>
//                                             {/* Search Type Dropdown */}
//                                             <div style={{ minWidth: '150px' }}>
//                                                 <select
//                                                     className="form-select"
//                                                     value={searchType}
//                                                     onChange={(e) => setSearchType(e.target.value)}
//                                                     style={{ height: "40px" }}
//                                                 >
//                                                     {searchOptions.map(option => (
//                                                         <option key={option.value} value={option.value}>
//                                                             {option.label}
//                                                         </option>
//                                                     ))}
//                                                 </select>
//                                             </div>

//                                             {/* Search Input */}
//                                             <div style={{ minWidth: '200px' }}>
//                                                 <input
//                                                     type="text"
//                                                     className="form-control"
//                                                     placeholder={getPlaceholderText()}
//                                                     value={searchQuery}
//                                                     onChange={(e) => setSearchQuery(e.target.value)}
//                                                     style={{ height: "40px" }}
//                                                 />
//                                             </div>
//                                         </div>
//                                     </div>



//                                     {/* Clear Filters Button */}
//                                     <div className="col-md-auto col-12">
//                                         <button
//                                             className="btn"
//                                             onClick={clearAllFilters}
//                                             style={{
//                                                 backgroundColor: '#6c757d',
//                                                 color: '#fff',
//                                                 height: "40px",
//                                                 padding: "0 15px"
//                                             }}
//                                         >
//                                             Clear Filters
//                                         </button>
//                                     </div>

//                                     {/* Refresh Data Button */}
//                                     <div className="col-md col-12" >
//                                         <div className="d-flex justify-content-start justify-content-md-end">
//                                             <button
//                                                 className="btn"
//                                                 onClick={() => window.location.reload()}
//                                                 style={{
//                                                     backgroundColor: 'rgb(230 109 51)',
//                                                     color: '#fff',
//                                                     height: "40px",
//                                                     padding: "0 20px"
//                                                 }}
//                                             >
//                                                 Refresh Data
//                                             </button>
//                                         </div>
//                                     </div>
//                                 </div>

//                                 <div className="sed pe-3">
//                                     <table style={tableStyle} className="table table-striped">
//                                         <thead>
//                                             <tr>
//                                                 <th style={thStyle}>S.NO</th>
//                                                 <th style={thStyle}>Date</th>
//                                                 <th style={thStyle}>Customer Name</th>
//                                                 <th style={thStyle}>Resturent Name</th>
//                                                 <th style={thStyle}>Email</th>
//                                                 <th style={thStyle}>Mobile</th>
//                                                 <th style={thStyle}>City</th>

//                                                 <th style={thStyle}>Vendor ID</th>
//                                                 <th style={thStyle}>Actions</th>
//                                             </tr>
//                                         </thead>
//                                         <tbody>
//                                             {filteredData.length ? (
//                                                 filteredData.map((c, idx) => (
//                                                     <tr key={c.subscriptionId || idx}>
//                                                         <td style={thTdStyle}>{idx + 1}</td>
//                                                         <td style={thTdStyle}>
//                                                             {formatDate(c?.registerTime)}
//                                                         </td>
//                                                         <td style={thTdStyle}>{c?.name || "—"}</td>
//                                                         {/* Restaurant Name */}
//                                                         <td style={thTdStyle}>
//                                                             {c?.registeredName || c?.companyName || "—"}
//                                                         </td>
//                                                         <td style={thTdStyle}>{c?.email || c?.customerEmail || "—"}</td>
//                                                         <td style={thTdStyle}>{c?.mobileNumber || "—"}</td>
//                                                         <td style={thTdStyle}>{c?.city || "—"}</td>

//                                                         <td style={thTdStyle}>{c?.vendorId || "—"}</td>
//                                                         <td style={thTdStyle}>
//                                                             <button
//                                                                 style={{ ...buttonStyle, color: "rgb(230 109 51)", fontWeight: "bold" }}
//                                                                 onClick={() => handleViewClick(c)}
//                                                             >
//                                                                 View
//                                                             </button>
//                                                         </td>
//                                                     </tr>
//                                                 ))
//                                             ) : (
//                                                 <tr>
//                                                     <td style={thTdStyle} colSpan={8}>
//                                                         {rolesData.length === 0
//                                                             ? "Loading data or no customers found."
//                                                             : (searchQuery.trim() || cityFilter || businessVerticalFilter)
//                                                                 ? "No data found with the specified filters."
//                                                                 : "No data available."}
//                                                     </td>
//                                                 </tr>
//                                             )}
//                                         </tbody>
//                                     </table>
//                                 </div>
//                             </>
//                         ) : (
//                             <div className="mt-4 rounded-3 shadow-sm">
//                                 <div className="d-flex align-items-center mb-4">
//                                     <button
//                                         onClick={handleBackClick}
//                                         className="btn fw-bold px-4 py-2"
//                                         style={{ backgroundColor: "rgb(230 109 51)", color: "#fff" }}
//                                     >
//                                         Back to List
//                                     </button>
//                                 </div>

//                                 {loading && (
//                                     <div className="text-center my-4">
//                                         <span className="spinner-border text-primary" />
//                                     </div>
//                                 )}

//                                 {!loading && vendorNotFound && (
//                                     <div className="text-center my-5 py-5">
//                                         <div style={{ fontSize: "24px", color: "#dc3545", marginBottom: "16px" }}>
//                                             ⚠️ Vendor Not Registered
//                                         </div>
//                                         <p style={{ fontSize: "16px", color: "#6c757d" }}>
//                                             This vendor has a subscription but is not registered in the system.
//                                             <br />
//                                             Vendor ID: {selectedClient?.vendorId}
//                                         </p>
//                                     </div>
//                                 )}

//                                 {!loading && !vendorNotFound && vendorDetails && (
//                                     <div className="register mt-4">
//                                         <div className="registertable bo2">
//                                             <table className="table table-bordered table-striped align-middle mt-4 w-100">
//                                                 <thead>
//                                                     <tr>
//                                                         <th style={detailThStyle}>Field</th>
//                                                         <th style={detailThStyle}>Value</th>
//                                                         <th style={detailThStyle}>Image</th>
//                                                         <th style={detailThStyle}>Status</th>
//                                                     </tr>
//                                                 </thead>

//                                                 <tbody>
//                                                     {rows.map((r, i) => {
//                                                         const isEditing = r.isEditing || false;

//                                                         const handleInputChange = (field, value) => {
//                                                             setRows((prevRows) =>
//                                                                 prevRows.map((row, idx) =>
//                                                                     idx === i
//                                                                         ? {
//                                                                             ...row,
//                                                                             value:
//                                                                                 typeof row.value === "object"
//                                                                                     ? { ...row.value, [field]: value }
//                                                                                     : value,
//                                                                         }
//                                                                         : row
//                                                                 )
//                                                             );
//                                                         };

//                                                         // Handle Order Type selection (multiple)
//                                                         const handleOrderTypeChange = (selectedValue) => {
//                                                             setRows((prevRows) =>
//                                                                 prevRows.map((row, idx) => {
//                                                                     if (idx === i) {
//                                                                         const currentValues = Array.isArray(row.value) ? row.value : [];
//                                                                         const isSelected = currentValues.includes(selectedValue);

//                                                                         if (isSelected) {
//                                                                             // Remove if already selected
//                                                                             return {
//                                                                                 ...row,
//                                                                                 value: currentValues.filter(v => v !== selectedValue)
//                                                                             };
//                                                                         } else {
//                                                                             // Add if not selected
//                                                                             return {
//                                                                                 ...row,
//                                                                                 value: [...currentValues, selectedValue]
//                                                                             };
//                                                                         }
//                                                                     }
//                                                                     return row;
//                                                                 })
//                                                             );
//                                                         };

//                                                         // Handle Business Plan selection
//                                                         const handleBusinessPlanChange = (selectedValue) => {
//                                                             setRows((prevRows) =>
//                                                                 prevRows.map((row, idx) =>
//                                                                     idx === i
//                                                                         ? {
//                                                                             ...row,
//                                                                             value: selectedValue,
//                                                                         }
//                                                                         : row
//                                                                 )
//                                                             );
//                                                         };

//                                                         // Handle Rating selection
//                                                         const handleRatingChange = (selectedValue) => {
//                                                             setRows((prevRows) =>
//                                                                 prevRows.map((row, idx) =>
//                                                                     idx === i
//                                                                         ? {
//                                                                             ...row,
//                                                                             value: parseFloat(selectedValue),
//                                                                         }
//                                                                         : row
//                                                                 )
//                                                             );
//                                                         };

//                                                         const handleImageChange = (e) => {
//                                                             const files = Array.from(e.target.files);
//                                                             const newImages = files.map((file) => ({
//                                                                 url: URL.createObjectURL(file),
//                                                                 file
//                                                             }));

//                                                             setRows(prev =>
//                                                                 prev.map((row, idx) =>
//                                                                     idx === i
//                                                                         ? {
//                                                                             ...row,
//                                                                             images: [...(row.images || []), ...newImages]
//                                                                         }
//                                                                         : row
//                                                                 )
//                                                             );
//                                                         };

//                                                         // Check if field is editable
//                                                         const isEditableField = ![
//                                                             "Selected Modules",
//                                                             "Remaining Days",
//                                                             "Business Vertical",
//                                                             "City"
//                                                         ].includes(r.key);

//                                                         return (
//                                                             <tr key={r.key || i}>
//                                                                 <td className="fw-bold text-center align-middle">{r.key}</td>

//                                                                 <td className="text-start align-middle">
//                                                                     {r.key === "Order Type" ? (
//                                                                         isEditing ? (
//                                                                             <div className="d-flex flex-column gap-2">
//                                                                                 {orderTypeOptions.map((option) => {
//                                                                                     const currentValues = Array.isArray(r.value) ? r.value : [];
//                                                                                     const isSelected = currentValues.includes(option);

//                                                                                     return (
//                                                                                         <div key={option} className="form-check">
//                                                                                             <input
//                                                                                                 className="form-check-input"
//                                                                                                 type="checkbox"
//                                                                                                 id={`order-type-${option}-${i}`}
//                                                                                                 checked={isSelected}
//                                                                                                 onChange={() => handleOrderTypeChange(option)}
//                                                                                             />
//                                                                                             <label
//                                                                                                 className="form-check-label"
//                                                                                                 htmlFor={`order-type-${option}-${i}`}
//                                                                                             >
//                                                                                                 {option}
//                                                                                             </label>
//                                                                                         </div>
//                                                                                     );
//                                                                                 })}
//                                                                             </div>
//                                                                         ) : (
//                                                                             Array.isArray(r.value) && r.value.length > 0
//                                                                                 ? r.value.join(", ")
//                                                                                 : "N/A"
//                                                                         )
//                                                                     ) : r.key === "Business Plan" ? (
//                                                                         isEditing && isEditableField ? (
//                                                                             <select
//                                                                                 value={r.value || ""}
//                                                                                 onChange={(e) => handleBusinessPlanChange(e.target.value)}
//                                                                                 className="form-select w-75"
//                                                                             >
//                                                                                 <option value="">Select Business Plan</option>
//                                                                                 {businessPlanOptions.map((option) => (
//                                                                                     <option key={option} value={option}>
//                                                                                         {option}
//                                                                                     </option>
//                                                                                 ))}
//                                                                             </select>
//                                                                         ) : (
//                                                                             r.value || "N/A"
//                                                                         )
//                                                                     ) : r.key === "Rating" ? (
//                                                                         isEditing && isEditableField ? (
//                                                                             <select
//                                                                                 value={r.value || 0}
//                                                                                 onChange={(e) => handleRatingChange(e.target.value)}
//                                                                                 className="form-select w-75"
//                                                                             >
//                                                                                 {ratingOptions.map((option) => (
//                                                                                     <option key={option.value} value={option.value}>
//                                                                                         {option.label}
//                                                                                     </option>
//                                                                                 ))}
//                                                                             </select>
//                                                                         ) : (
//                                                                             <div>
//                                                                                 {r.value || 0} {r.value ? "★" : ""}
//                                                                             </div>
//                                                                         )
//                                                                     ) : r.key === "Company Name" ? (
//                                                                         <div>
//                                                                             {isEditing && isEditableField ? (
//                                                                                 <input
//                                                                                     type="text"
//                                                                                     value={r.value || ""}
//                                                                                     onChange={(e) => handleInputChange("value", e.target.value)}
//                                                                                     className="form-control d-inline-block w-75 mb-2"
//                                                                                 />
//                                                                             ) : (
//                                                                                 r.value || "N/A"
//                                                                             )}
//                                                                         </div>
//                                                                     ) : r.key === "Bank Details" ? (
//                                                                         ["holderName", "branchName", "accountNumber", "ifscCode"].map((field) => (
//                                                                             <div key={field} className="mb-1">
//                                                                                 <strong>{field.replace(/([A-Z])/g, " $1")}:</strong>{" "}
//                                                                                 {isEditing && isEditableField ? (
//                                                                                     <input
//                                                                                         type="text"
//                                                                                         value={r.value?.[field] || ""}
//                                                                                         onChange={(e) => handleInputChange(field, e.target.value)}
//                                                                                         className="form-control d-inline-block w-75 ms-2"
//                                                                                     />
//                                                                                 ) : (
//                                                                                     r.value?.[field] || "N/A"
//                                                                                 )}
//                                                                             </div>
//                                                                         ))
//                                                                     ) : r.key === "Address" ? (
//                                                                         ["doorNo", "street", "city", "state", "pincode", "landmark", "latitude", "longitude"].map((field) => (
//                                                                             <div key={field} className="mb-1">
//                                                                                 <strong>{field.charAt(0).toUpperCase() + field.slice(1)}:</strong>{" "}
//                                                                                 {isEditing && isEditableField ? (
//                                                                                     <input
//                                                                                         type="text"
//                                                                                         value={r.value?.[field] || ""}
//                                                                                         onChange={(e) => handleInputChange(field, e.target.value)}
//                                                                                         className="form-control d-inline-block w-75 ms-2"
//                                                                                     />
//                                                                                 ) : (
//                                                                                     r.value?.[field] || "N/A"
//                                                                                 )}
//                                                                             </div>
//                                                                         ))
//                                                                     ) : r.key === "Trade License" ||
//                                                                         r.key === "FSSI License" ||
//                                                                         r.key === "Labour License" ? (
//                                                                         <>
//                                                                             <div className="mb-2">
//                                                                                 <strong>Start Date:</strong>{" "}
//                                                                                 {isEditing && isEditableField ? (
//                                                                                     <input
//                                                                                         type="date"
//                                                                                         value={safeDateToISOString(r.value?.startDate)}
//                                                                                         onChange={(e) => handleInputChange("startDate", e.target.value)}
//                                                                                         className="form-control d-inline-block w-75 ms-2"
//                                                                                     />
//                                                                                 ) : (
//                                                                                     safeDateDisplay(r.value?.startDate)
//                                                                                 )}
//                                                                             </div>
//                                                                             <div>
//                                                                                 <strong>End Date:</strong>{" "}
//                                                                                 {isEditing && isEditableField ? (
//                                                                                     <input
//                                                                                         type="date"
//                                                                                         value={safeDateToISOString(r.value?.endDate)}
//                                                                                         onChange={(e) => handleInputChange("endDate", e.target.value)}
//                                                                                         className="form-control d-inline-block w-75 ms-2"
//                                                                                     />
//                                                                                 ) : (
//                                                                                     safeDateDisplay(r.value?.endDate)
//                                                                                 )}
//                                                                             </div>
//                                                                         </>
//                                                                     ) : r.key === "Trade License Number" ||
//                                                                         r.key === "Labour License Number" ||
//                                                                         r.key === "FSSAI License Number" ||
//                                                                         r.key === "Owner Name" ||
//                                                                         r.key === "Position" ||
//                                                                         r.key === "BrandName" ||
//                                                                         r.key === "Phone No" ||
//                                                                         r.key === "Email ID" ||
//                                                                         r.key === "Website" ||
//                                                                         r.key === "GST No." ||
//                                                                         r.key === "AADHAR CARD NO" ||
//                                                                         r.key === "PAN CARD NO" ? (
//                                                                         isEditing && isEditableField ? (
//                                                                             <input
//                                                                                 type="text"
//                                                                                 value={r.value || ""}
//                                                                                 onChange={(e) => handleInputChange("value", e.target.value)}
//                                                                                 className="form-control d-inline-block w-75"
//                                                                             />
//                                                                         ) : (
//                                                                             r.value || "N/A"
//                                                                         )
//                                                                     ) : r.key === "Register Documents" ? (
//                                                                         "Registered Documents"
//                                                                     ) : r.key === "Passbook" ? (
//                                                                         "Passbook Image"
//                                                                     ) : (
//                                                                         r.value || "N/A"
//                                                                     )}
//                                                                 </td>

//                                                                 <td className="text-center align-middle">
//                                                                     {isEditing && isEditableField ? (
//                                                                         <>
//                                                                             {r.key === "Company Name" && (
//                                                                                 <input
//                                                                                     type="file"
//                                                                                     accept="image/*"
//                                                                                     onChange={handleImageChange}
//                                                                                     className="form-control mb-2"
//                                                                                 />
//                                                                             )}
//                                                                             {r.key === "Register Documents" && (
//                                                                                 <input
//                                                                                     type="file"
//                                                                                     multiple
//                                                                                     accept="image/*"
//                                                                                     onChange={handleImageChange}
//                                                                                     className="form-control mb-2"
//                                                                                 />
//                                                                             )}
//                                                                             {r.key === "AADHAR CARD NO" && (
//                                                                                 <input
//                                                                                     type="file"
//                                                                                     multiple
//                                                                                     accept="image/*"
//                                                                                     onChange={handleImageChange}
//                                                                                     className="form-control mb-2"
//                                                                                 />
//                                                                             )}
//                                                                             {r.key === "PAN CARD NO" && (
//                                                                                 <input
//                                                                                     type="file"
//                                                                                     accept="image/*"
//                                                                                     onChange={handleImageChange}
//                                                                                     className="form-control mb-2"
//                                                                                 />
//                                                                             )}
//                                                                             {r.key === "Trade License" && (
//                                                                                 <input
//                                                                                     type="file"
//                                                                                     accept="image/*"
//                                                                                     onChange={handleImageChange}
//                                                                                     className="form-control mb-2"
//                                                                                 />
//                                                                             )}
//                                                                             {r.key === "FSSI License" && (
//                                                                                 <input
//                                                                                     type="file"
//                                                                                     accept="image/*"
//                                                                                     onChange={handleImageChange}
//                                                                                     className="form-control mb-2"
//                                                                                 />
//                                                                             )}
//                                                                             {r.key === "Labour License" && (
//                                                                                 <input
//                                                                                     type="file"
//                                                                                     accept="image/*"
//                                                                                     onChange={handleImageChange}
//                                                                                     className="form-control mb-2"
//                                                                                 />
//                                                                             )}
//                                                                             {r.key === "Bank Details" && (
//                                                                                 <input
//                                                                                     type="file"
//                                                                                     accept="image/*"
//                                                                                     onChange={handleImageChange}
//                                                                                     className="form-control mb-2"
//                                                                                 />
//                                                                             )}
//                                                                             {r.key === "Passbook" && (
//                                                                                 <input
//                                                                                     type="file"
//                                                                                     accept="image/*"
//                                                                                     onChange={handleImageChange}
//                                                                                     className="form-control mb-2"
//                                                                                 />
//                                                                             )}
//                                                                             <ImageDisplay images={r.images} fieldName={r.key} />
//                                                                         </>
//                                                                     ) : (
//                                                                         <ImageDisplay images={r.images} fieldName={r.key} />
//                                                                     )}
//                                                                 </td>

//                                                                 <td className="text-center align-middle">
//                                                                     {isEditing && isEditableField ? (
//                                                                         <>
//                                                                             <button
//                                                                                 className="btn btn-sm btn-success me-2"
//                                                                                 style={{ minWidth: 80 }}
//                                                                                 onClick={() => handleSaveRow(i)}
//                                                                             >
//                                                                                 Save
//                                                                             </button>
//                                                                             <button
//                                                                                 className="btn btn-sm btn-secondary"
//                                                                                 style={{ minWidth: 80 }}
//                                                                                 onClick={() =>
//                                                                                     setRows((prev) =>
//                                                                                         prev.map((row, idx) =>
//                                                                                             idx === i ? { ...row, isEditing: false } : row
//                                                                                         )
//                                                                                     )
//                                                                                 }
//                                                                             >
//                                                                                 Cancel
//                                                                             </button>
//                                                                         </>
//                                                                     ) : (
//                                                                         <div style={{ display: "flex", gap: "10px" }}>
//                                                                             {isFieldVerified(r.key, r.value, vendorDetails, r.images) ? (
//                                                                                 <button
//                                                                                     className="btn btn-sm btn-success"
//                                                                                     style={{ minWidth: 80 }}
//                                                                                     disabled
//                                                                                 >
//                                                                                     Verified ✓
//                                                                                 </button>
//                                                                             ) : (
//                                                                                 <button
//                                                                                     className="btn btn-sm btn-warning"
//                                                                                     style={{ minWidth: 80 }}
//                                                                                     onClick={() => handleVerifyy(i)}
//                                                                                     disabled={!canVerifyField(r.key, r.value, vendorDetails, r.images) || !isEditableField}
//                                                                                 >
//                                                                                     Verify
//                                                                                 </button>
//                                                                             )}

//                                                                             {isFieldRejected(r.key, vendorDetails) ? (
//                                                                                 <button
//                                                                                     className="btn btn-sm btn-danger"
//                                                                                     style={{ minWidth: 80 }}
//                                                                                     disabled
//                                                                                 >
//                                                                                     Rejected ✗
//                                                                                 </button>
//                                                                             ) : (
//                                                                                 <button
//                                                                                     className="btn btn-sm btn-secondary"
//                                                                                     style={{ minWidth: 80 }}
//                                                                                     onClick={() => handleReject(i)}
//                                                                                     disabled={
//                                                                                         r.key === "Rating" ? true :
//                                                                                             !hasValidData({ key: r.key, value: r.value, images: r.images }, vendorDetails) ||
//                                                                                             !isEditableField
//                                                                                     }
//                                                                                 >
//                                                                                     Reject
//                                                                                 </button>
//                                                                             )}

//                                                                             {/* Edit button - only show for editable fields */}
//                                                                             {isEditableField && (
//                                                                                 <button
//                                                                                     className="btn btn-sm btn-primary"
//                                                                                     style={{ minWidth: 80 }}
//                                                                                     onClick={() =>
//                                                                                         setRows((prev) =>
//                                                                                             prev.map((row, idx) =>
//                                                                                                 idx === i ? { ...row, isEditing: true } : row
//                                                                                             )
//                                                                                         )
//                                                                                     }
//                                                                                 >
//                                                                                     Edit
//                                                                                 </button>
//                                                                             )}
//                                                                         </div>
//                                                                     )}
//                                                                 </td>
//                                                             </tr>
//                                                         );
//                                                     })}
//                                                 </tbody>
//                                             </table>
//                                         </div>
//                                     </div>
//                                 )}

//                                 <div style={{
//                                     display: "flex",
//                                     justifyContent: "center",
//                                     marginTop: "15px"
//                                 }}>
//                                     {vendorDetails?.approvalStatus ? (
//                                         <span
//                                             style={{
//                                                 padding: "8px 20px",
//                                                 fontWeight: "600",
//                                                 borderRadius: "6px",
//                                                 backgroundColor: "#d1fae5",
//                                                 color: "#065f46"
//                                             }}
//                                         >
//                                             Approved ✓
//                                         </span>
//                                     ) : (
//                                         <button
//                                             className="btn btn-success"
//                                             style={{
//                                                 padding: "8px 20px",
//                                                 fontWeight: "600",
//                                                 borderRadius: "6px"
//                                             }}
//                                             onClick={handleApproveAll}
//                                         >
//                                             Approve
//                                         </button>
//                                     )}
//                                 </div>
//                             </div>
//                         )}
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// const tableStyle = { width: "100%", borderCollapse: "collapse", marginTop: 5 };
// const thTdStyle = { border: "1px solid #ddd", textAlign: "center", padding: "8px", verticalAlign: "middle" };
// const thStyle = { ...thTdStyle, backgroundColor: "rgb(230 109 51)", color: "#fff", fontWeight: "bold", whiteSpace: "nowrap" };
// const buttonStyle = { backgroundColor: "transparent", border: "none", cursor: "pointer" };

// const detailThStyle = {
//     ...thTdStyle,
//     backgroundColor: "rgb(230 109 51)",
//     color: "#fff",
//     fontWeight: 600,
//     padding: "0.75rem",
//     verticalAlign: "middle",
//     border: "1px solid #dee2e6",
//     textAlign: "center"
// };

// export default FoodPaidClents;









// import React, { useState, useEffect, useRef, useMemo } from "react";
// import axios from "axios";
// import { Link } from "react-router-dom";
// import { useLoader } from '../../../../context/LoaderProvider.jsx';
// import {
//     getVendorDetails,
//     updateVendorDetails,
//     getAllEnquiries,
//     approveVendor,
//     verifyVendorStatus
// } from "../../../Servicefile/clientManagementService.jsx";

// // ============================================
// // PREMIUM ICONS COMPONENT
// // ============================================
// const Icons = {
//     Search: () => (
//         <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//             <circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/>
//         </svg>
//     ),
//     Refresh: () => (
//         <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//             <path d="M23 4v6h-6M1 20v-6h6"/>
//             <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"/>
//         </svg>
//     ),
//     Clear: () => (
//         <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//             <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
//         </svg>
//     ),
//     Back: () => (
//         <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//             <polyline points="15 18 9 12 15 6"/>
//         </svg>
//     ),
//     Edit: () => (
//         <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//             <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
//             <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
//         </svg>
//     ),
//     Check: () => (
//         <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
//             <polyline points="20 6 9 17 4 12"/>
//         </svg>
//     ),
//     X: () => (
//         <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//             <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
//         </svg>
//     ),
//     Save: () => (
//         <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//             <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"/>
//             <polyline points="17 21 17 13 7 13 7 21"/>
//             <polyline points="7 3 7 8 15 8"/>
//         </svg>
//     ),
//     Upload: () => (
//         <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//             <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
//             <polyline points="17 8 12 3 7 8"/>
//             <line x1="12" y1="3" x2="12" y2="15"/>
//         </svg>
//     ),
//     Approved: () => (
//         <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#065f46" strokeWidth="2">
//             <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
//             <polyline points="22 4 12 14.01 9 11.01"/>
//         </svg>
//     )
// };

// // ============================================
// // PREMIUM STYLES
// // ============================================
// const styles = {
//     container: {
//         padding: '1px 6px',

//         borderRadius: '16px',

//         height: 'calc(100vh - 200px)',
//         display: 'flex',
//         flexDirection: 'column'
//     },
//     header: {
//         display: 'flex',
//         justifyContent: 'space-between',
//         alignItems: 'center',
//         padding: '0 0 16px 0',
//         borderBottom: '2px solid #e9ecef',
//         flexWrap: 'wrap',
//         gap: '12px'
//     },
//     title: {
//         fontSize: '20px',
//         fontWeight: '600',
//         color: '#2d3748',
//         letterSpacing: '-0.3px',
//         display: 'flex',
//         alignItems: 'center',
//         gap: '10px'
//     },
//     titleBadge: {
//         background: 'rgb(230 109 51)',
//         color: 'white',
//         fontSize: '12px',
//         fontWeight: '500',
//         padding: '2px 12px',
//         borderRadius: '12px',
//         letterSpacing: '0.3px'
//     },
//     filtersContainer: {
//         display: 'flex',
//         flexWrap: 'wrap',
//         alignItems: 'center',
//         gap: '10px',
//         padding: '12px 0',
//         borderBottom: '1px solid #edf2f7',
//         marginBottom: '16px'
//     },
//     searchGroup: {
//         display: 'flex',
//         alignItems: 'center',
//         gap: '8px',
//         flex: '1 1 auto',
//         minWidth: '280px'
//     },
//     select: {
//         padding: '8px 12px',
//         border: '1px solid #e2e8f0',
//         borderRadius: '8px',
//         background: 'white',
//         fontSize: '13px',
//         fontWeight: '500',
//         color: '#2d3748',
//         outline: 'none',
//         transition: 'all 0.2s ease',
//         height: '38px',
//         minWidth: '140px',
//         cursor: 'pointer'
//     },
//     input: {
//         flex: '1',
//         padding: '8px 14px',
//         border: '1px solid #e2e8f0',
//         borderRadius: '8px',
//         fontSize: '13px',
//         color: '#2d3748',
//         outline: 'none',
//         transition: 'all 0.2s ease',
//         height: '38px',
//         background: 'white',
//         minWidth: '180px'
//     },
//     button: {
//         padding: '8px 16px',
//         borderRadius: '8px',
//         border: 'none',
//         fontWeight: '500',
//         fontSize: '13px',
//         display: 'flex',
//         alignItems: 'center',
//         gap: '6px',
//         cursor: 'pointer',
//         transition: 'all 0.2s ease',
//         height: '38px',
//         whiteSpace: 'nowrap'
//     },
//     buttonPrimary: {
//         background: 'rgb(230 109 51)',
//         color: 'white'
//     },
//     buttonSecondary: {
//         background: '#e2e8f0',
//         color: '#4a5568'
//     },
//     buttonSuccess: {
//         background: '#48bb78',
//         color: 'white'
//     },
//     buttonDanger: {
//         background: '#fc8181',
//         color: 'white'
//     },
//     buttonOutline: {
//         background: 'transparent',
//         border: '1px solid #e2e8f0',
//         color: '#4a5568'
//     },
//     tableWrapper: {
//         borderRadius: '10px',
//         border: '1px solid #edf2f7',
//         background: 'white',
//         overflow: 'auto',
//         maxHeight: '500px',
//         scrollbarWidth:"none",
//         position: 'relative'
//     },
//     table: {
//         width: '100%',
//         fontSize: '13px',
//         borderCollapse: 'collapse',
//         minWidth: '900px'
//     },
//     thead: {
//         position: 'sticky',
//         top: 0,
//         zIndex: 10
//     },
//     th: {
//         padding: '10px 12px',
//         textAlign: 'left',
//         fontWeight: '600',
//         fontSize: '11px',
//         textTransform: 'uppercase',
//         letterSpacing: '0.5px',
//         color: 'white',
//         background: '#e66d33',
//         borderBottom: '2px solid #edf2f7',
//         whiteSpace: 'nowrap'
//     },
//     td: {
//         padding: '10px 12px',
//         borderBottom: '1px solid #f1f5f9',
//         color: '#2d3748',
//         fontSize: '13px'
//     },
//     detailHeader: {
//         display: 'flex',
//         alignItems: 'center',
//         gap: '12px',
//         padding: '16px 0',
//         borderBottom: '2px solid #e9ecef',
//         marginBottom: '16px'
//     },
//     detailTitle: {
//         fontSize: '18px',
//         fontWeight: '600',
//         color: '#2d3748',
//         flex: 1
//     },
//     detailTableWrapper: {
//         borderRadius: '10px',
//         border: '1px solid #edf2f7',
//         background: 'white',
//         overflow: 'auto',
//         maxHeight: '60vh'
//     },
//     detailTable: {
//         width: '100%',
//         fontSize: '13px',
//         borderCollapse: 'collapse',
//         minWidth: '700px'
//     },
//     detailTh: {
//         padding: '10px 14px',
//         textAlign: 'center',
//         fontWeight: '600',
//         fontSize: '11px',
//         textTransform: 'uppercase',
//         letterSpacing: '0.5px',
//         color: 'white',
//         background: 'rgb(230 109 51)',
//         border: '1px solid #dee2e6'
//     },
//     detailTd: {
//         padding: '10px 14px',
//         border: '1px solid #dee2e6',
//         verticalAlign: 'middle',
//         fontSize: '13px'
//     },
//     statusBadge: {
//         display: 'inline-flex',
//         alignItems: 'center',
//         gap: '4px',
//         padding: '3px 12px',
//         borderRadius: '20px',
//         fontSize: '11px',
//         fontWeight: '500',
//         letterSpacing: '0.3px'
//     },
//     verifiedBadge: {
//         background: '#c6f6d5',
//         color: '#276749'
//     },
//     rejectedBadge: {
//         background: '#fed7d7',
//         color: '#9b2c2c'
//     },
//     pendingBadge: {
//         background: '#fefcbf',
//         color: '#975a16'
//     },
//     emptyState: {
//         display: 'flex',
//         flexDirection: 'column',
//         alignItems: 'center',
//         justifyContent: 'center',
//         padding: '60px 20px',
//         color: '#a0aec0'
//     },
//     emptyStateText: {
//         marginTop: '16px',
//         fontSize: '16px',
//         fontWeight: '500',
//         color: '#4a5568'
//     },
//     emptyStateSubtext: {
//         fontSize: '13px',
//         color: '#a0aec0',
//         marginTop: '4px'
//     },
//     statsBar: {
//         display: 'flex',
//         alignItems: 'center',
//         gap: '16px',
//         padding: '8px 0 0 0',
//         fontSize: '12px',
//         color: '#718096'
//     },
//     statItem: {
//         display: 'flex',
//         alignItems: 'center',
//         gap: '4px'
//     },
//     statNumber: {
//         fontWeight: '600',
//         color: '#2d3748'
//     },
//     approvalContainer: {
//         display: 'flex',
//         justifyContent: 'center',
//         padding: '20px 0',
//         marginTop: '16px',
//         borderTop: '2px solid #e9ecef'
//     }
// };

// // ============================================
// // HELPER FUNCTIONS
// // ============================================
// const normalizeImageUrl = (url) => {
//     if (!url || url === "N/A" || typeof url !== 'string') return null;
//     if (url.startsWith('http')) return url;
//     const cleanUrl = url.replace(/^\//, '');
//     return `http://img.maamaas.com:8080/${cleanUrl}`;
// };

// const getDefaultClientDetailsRows = () => [
//     { key: "Owner Name", value: "", isUpload: false },
//     { key: "Business Plan", value: "", isUpload: false },
//     { key: "Position", value: "", isUpload: false },
//     { key: "Branding", value: "", isUpload: false },
//     { key: "Company Name", value: "", isUpload: false },
//     { key: "Register Documents", value: "", isUpload: true },
//     { key: "Phone No", value: "", isUpload: false },
//     { key: "Email ID", value: "", isUpload: false },
//     {
//         key: "Bank Details",
//         value: {
//             holderName: "",
//             branchName: "",
//             accountNumber: "",
//             ifscCode: "",
//         },
//         isUpload: false,
//     },
//     { key: "Passbook", value: "", isUpload: true },
//     { key: "AADHAR CARD NO", value: "", isUpload: false },
//     { key: "PAN CARD NO", value: "", isUpload: false },
//     { key: "Website", value: "", isUpload: false },
//     { key: "GST No.", value: "", isUpload: false },
// ];

// const STATUS_FIELD_MAP = {
//     "Owner Name": "ownerNameStatus",
//     "Business Plan": "businessPlanStatus",
//     "Company Name": "registeredNameStatus",
//     "Register Documents": "registeredDocumentsStatus",
//     "Phone No": "mobileNumberStatus",
//     "Email ID": "emailStatus",
//     "AADHAR CARD NO": "aadharNumberStatus",
//     "PAN CARD NO": "panCardStatus",
//     "Website": "websiteNameStatus",
//     "GST No.": "gstNumberStatus",
//     "Trade License": "tradeLicenseStatus",
//     "FSSI License": "fssaiLicenseStatus",
//     "Labour License": "labourLicenseStatus",
//     "Bank Details": "blankChequeStatus",
//     "Passbook": "passbookStatus",
//     "Address": "addressStatus",
//     "Order Type": "orderTypeStatus",
//     "Business Vertical": "businessVerticalStatus",
//     "Rating": "ratingStatus",
//     "Trade License Number": "tradeLicenseStatus",
//     "FSSAI License Number": "fssaiLicenseStatus",
//     "Labour License Number": "labourLicenseStatus",
// };

// const orderTypeOptions = ["DINE_IN", "TAKEAWAY", "DELIVERY", "TABLE_DINE_IN"];
// const businessPlanOptions = ["HOTEL", "RESTAURANT", "CAFE", "CLOUD_KITCHEN", "FOOD_COURT", "STREET_FOOD", "BAKERY"];
// const businessVerticalOptions = ["FOOD_AND_BEVERAGES", "CATERINGS_SERVICES", "LOGISTICS_SUPPLY", "FRESH_GROCERIES"];

// const ratingOptions = [
//     { value: 0, label: "0 - Not Rated" },
//     { value: 1, label: "1 ★" },
//     { value: 1.5, label: "1.5 ★" },
//     { value: 2, label: "2 ★" },
//     { value: 2.5, label: "2.5 ★" },
//     { value: 3, label: "3 ★" },
//     { value: 3.5, label: "3.5 ★" },
//     { value: 4, label: "4 ★" },
//     { value: 4.5, label: "4.5 ★" },
//     { value: 5, label: "5 ★" }
// ];

// const safeDateToISOString = (dateString) => {
//     if (!dateString || dateString === "N/A" || dateString === "Invalid Date") return "";
//     const date = new Date(dateString);
//     if (isNaN(date.getTime())) return "";
//     return date.toISOString().split("T")[0];
// };

// const safeDateDisplay = (dateString) => {
//     if (!dateString || dateString === "N/A" || dateString === "Invalid Date") return "N/A";
//     const date = new Date(dateString);
//     if (isNaN(date.getTime())) return "N/A";
//     return date.toLocaleDateString();
// };

// const hasValidData = (row, vendorDetails) => {
//     if (!row) return false;
//     const field = row.key;
//     const value = row.value;

//     if (Array.isArray(value)) {
//         return value.length > 0 && value[0] !== "N/A";
//     }

//     if (typeof value === 'string') {
//         return value && value !== "N/A" && value.trim() !== "";
//     }

//     if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
//         if (field === "Address" || field === "Bank Details" ||
//             field === "Trade License" || field === "FSSI License" || field === "Labour License") {
//             return Object.values(value).some(val =>
//                 val && val !== "N/A" && val.toString().trim() !== ""
//             );
//         }
//         return Object.keys(value).length > 0;
//     }

//     if (typeof value === 'number') {
//         return value !== undefined && value !== null;
//     }

//     if (value === "Registered Documents" || value === "Passbook Image") {
//         return row.images && row.images.length > 0;
//     }

//     return false;
// };

// const isFieldVerified = (rowKey, rowValue, vendorDetails, rowImages) => {
//     const normalisedKey = rowKey.trim().replace(/\.$/, "");
//     const statusField = STATUS_FIELD_MAP[normalisedKey];

//     if (statusField && vendorDetails && vendorDetails[statusField] !== undefined) {
//         return vendorDetails[statusField] === true;
//     }

//     const rowForValidation = { key: rowKey, value: rowValue, images: rowImages };

//     const alwaysAutoVerifyFields = [
//         "Business Vertical", "Order Type", "Address", "Rating",
//         "Business Plan", "Position", "BrandName", "Website",
//         "Phone No", "Email ID", "GST No.",
//         "Trade License Number", "FSSAI License Number", "Labour License Number",
//         "Owner Name", "Company Name", "AADHAR CARD NO", "PAN CARD NO"
//     ];

//     if (alwaysAutoVerifyFields.includes(rowKey)) {
//         return hasValidData(rowForValidation, vendorDetails);
//     }

//     const documentFields = [
//         "Register Documents", "Trade License", "FSSI License",
//         "Labour License", "Bank Details", "Passbook"
//     ];

//     if (documentFields.includes(rowKey)) {
//         return rowImages && rowImages.length > 0;
//     }

//     return false;
// };

// const isFieldRejected = (rowKey, vendorDetails) => {
//     const normalisedKey = rowKey.trim().replace(/\.$/, "");
//     const statusField = STATUS_FIELD_MAP[normalisedKey];
//     if (!statusField || !vendorDetails) return false;
//     return vendorDetails[statusField] === false;
// };

// const canVerifyField = (rowKey, rowValue, vendorDetails, rowImages) => {
//     return hasValidData({ key: rowKey, value: rowValue, images: rowImages }, vendorDetails);
// };

// // ============================================
// // MAIN COMPONENT
// // ============================================
// const FoodPaidClents = () => {
//     /* -------- list‑screen state -------- */
//     const [rolesData, setRolesData] = useState([]);
//     const [screenWidth, setScreenWidth] = useState(window.innerWidth);
//     const { showLoader, hideLoader } = useLoader();

//     // Filter states
//     const [searchType, setSearchType] = useState("vendorId");
//     const [searchQuery, setSearchQuery] = useState("");
//     const [cityFilter, setCityFilter] = useState("");
//     const [businessVerticalFilter, setBusinessVerticalFilter] = useState("");
//     const [filteredData, setFilteredData] = useState([]);

//     /* -------- detail‑screen state -------- */
//     const [selectedClient, setSelectedClient] = useState(null);
//     const [vendorDetails, setVendorDetails] = useState(null);
//     const [vendorNotFound, setVendorNotFound] = useState(false);
//     const [vendorError, setVendorError] = useState(null);
//     const [loading, setLoading] = useState(false);

//     const [rows, setRows] = useState(getDefaultClientDetailsRows());
//     const [verifiedRows, setVerifiedRows] = useState([]);
//     const [rejectedRows, setRejectedRows] = useState([]);
//     const [isApproved, setIsApproved] = useState(false);
//     const [imageLoadErrors, setImageLoadErrors] = useState(new Set());

//     const fileInputRef = useRef(null);
//     const [vendorData, setVendorData] = useState({});
//     const [rowId, setRowId] = useState(null);

//     // Screen resize effect
//     useEffect(() => {
//         const handleResize = () => setScreenWidth(window.innerWidth);
//         window.addEventListener("resize", handleResize);
//         return () => window.removeEventListener("resize", handleResize);
//     }, []);

//     const getCurrentVendorId = () => {
//         return (
//             selectedClient?.vendorId ||
//             selectedClient?.vendorEnquiry?.vendorId ||
//             vendorDetails?.vendorId ||
//             null
//         );
//     };

//     const handleApproveAll = async () => {
//         try {
//             const token = localStorage.getItem("authToken");
//             const vendorId = getCurrentVendorId();

//             if (!vendorId) return alert("Vendor ID not found ❌");

//             const body = {
//                 approvalStatus: true,
//                 approvalRemarks: "Approved by admin"
//             };

//             const data = await approveVendor(vendorId, body, token);
//             alert("Vendor Approved Successfully ✅");
//             fetchVendorDetails(vendorId);

//         } catch (error) {
//             console.error("Approval Error:", error);
//             alert("Approval Failed ❌");
//         }
//     };

//     const vendorId = getCurrentVendorId();

//     const handleImageError = (imageUrl, fieldName, index) => {
//         const errorKey = `${fieldName}-${index}`;
//         setImageLoadErrors(prev => new Set([...prev, errorKey]));
//     };

//     const handleImageLoad = (imageUrl, fieldName, index) => {
//         const errorKey = `${fieldName}-${index}`;
//         setImageLoadErrors(prev => {
//             const newSet = new Set(prev);
//             newSet.delete(errorKey);
//             return newSet;
//         });
//     };

//     const isImageFailed = (fieldName, index) => {
//         return imageLoadErrors.has(`${fieldName}-${index}`);
//     };

//     const fetchVendorDetails = async (vendorId) => {
//         if (!vendorId) return;
//         setLoading(true);
//         setVendorNotFound(false);
//         setVendorError(null);

//         const token = localStorage.getItem("authToken");

//         try {
//             const data = await getVendorDetails(vendorId, token);
//             setVendorDetails(data);
//             setVendorNotFound(false);
//             setVendorError(null);
//         } catch (err) {
//             console.error("❌ get-vendor-details error:", err);
//             if (err.response?.status === 500 && err.response?.data?.message === "vendorId not found") {
//                 setVendorNotFound(true);
//                 setVendorDetails(null);
//                 setVendorError("Vendor not registered");
//             } else {
//                 setVendorError("Failed to fetch vendor details");
//             }
//         } finally {
//             setLoading(false);
//         }
//     };

//     const formatDate = (date) => {
//         if (!date) return "—";
//         const d = new Date(date);
//         if (isNaN(d.getTime())) return "—";
//         const day = String(d.getDate()).padStart(2, "0");
//         const month = String(d.getMonth() + 1).padStart(2, "0");
//         const year = d.getFullYear();
//         return `${day}-${month}-${year}`;
//     };

//     const handleSaveRow = async (rowIndex) => {
//         const token = localStorage.getItem("authToken") || localStorage.getItem("token");

//         if (!token) {
//             alert("No authentication token found");
//             return;
//         }

//         try {
//             const vendorId = getCurrentVendorId();
//             if (!vendorId) {
//                 alert("Vendor ID not found");
//                 return;
//             }

//             const row = rows[rowIndex];
//             const formData = new FormData();
//             const vendorData = {};

//             const fieldMapping = {
//                 "Owner Name": "ownerName",
//                 "Phone No": "mobileNumber",
//                 "Position": "position",
//                 "Branding": "brandName",
//                 "Website": "websiteName",
//                 "Email ID": "email",
//                 "Company Name": "registeredName",
//                 "AADHAR CARD NO": "aadharNumber",
//                 "PAN CARD NO": "panCardNumber",
//                 "GST No.": "gstNumber",
//                 "Order Type": "orderTypes",
//                 "Business Plan": "businessPlan",
//                 "Trade License Number": "tradeLicenseNumber",
//                 "FSSAI License Number": "fssaiLicenseNumber",
//                 "Labour License Number": "labourLicenseNumber",
//                 "Rating": "rating"
//             };

//             const backendFieldName = fieldMapping[row.key];

//             if (backendFieldName && row.value) {
//                 if (row.key === "Order Type") {
//                     vendorData[backendFieldName] = Array.isArray(row.value) ? row.value : [row.value];
//                 } else if (row.key === "Rating") {
//                     vendorData[backendFieldName] = parseFloat(row.value) || 0;
//                 } else if (row.value !== "N/A") {
//                     vendorData[backendFieldName] = row.value;
//                 }
//             }

//             if (row.key === "Address" && typeof row.value === "object") {
//                 vendorData.doorNumber = row.value.doorNo || "";
//                 vendorData.addressLine = row.value.street || "";
//                 vendorData.city = row.value.city || "";
//                 vendorData.state = row.value.state || "";
//                 vendorData.pincode = row.value.pincode || "";
//                 vendorData.landMark = row.value.landmark || "";
//                 vendorData.latitude = row.value.latitude ? parseFloat(row.value.latitude) : null;
//                 vendorData.longitude = row.value.longitude ? parseFloat(row.value.longitude) : null;
//             }

//             if (row.key === "Bank Details" && typeof row.value === "object") {
//                 vendorData.holderName = row.value.holderName || "";
//                 vendorData.branchName = row.value.branchName || "";
//                 vendorData.accountNumber = row.value.accountNumber || "";
//                 vendorData.ifscCode = row.value.ifscCode || "";
//             }

//             if (row.key === "Trade License" && typeof row.value === "object") {
//                 vendorData.tradeLicenseStartDate = row.value.startDate || "";
//                 vendorData.tradeLicenseEndDate = row.value.endDate || "";
//             }

//             if (row.key === "FSSI License" && typeof row.value === "object") {
//                 vendorData.fssaiStartDate = row.value.startDate || "";
//                 vendorData.fssaiEndDate = row.value.endDate || "";
//             }

//             if (row.key === "Labour License" && typeof row.value === "object") {
//                 vendorData.labourStartDate = row.value.startDate || "";
//                 vendorData.labourEndDate = row.value.endDate || "";
//             }

//             formData.append("vendorData", new Blob([JSON.stringify(vendorData)], { type: "application/json" }));

//             if (row.images?.length > 0) {
//                 row.images.forEach((img, idx) => {
//                     if (img.file) {
//                         const imageFieldName = getImageFieldName(row.key, idx);
//                         formData.append(imageFieldName, img.file);
//                     }
//                 });
//             }

//             const response = await updateVendorDetails(vendorId, formData, token);
//             alert("Data updated successfully!");

//             setRows((prev) =>
//                 prev.map((r, idx) =>
//                     idx === rowIndex ? { ...r, isEditing: false } : r
//                 )
//             );

//             await fetchVendorDetails(vendorId);

//         } catch (err) {
//             console.error("Full Update Error:", err);
//             alert(err.response?.data?.message || err.message || "Failed to update vendor");
//         }
//     };

//     const getImageFieldName = (rowKey, imageIndex) => {
//         const fieldMap = {
//             "Register Documents": imageIndex === 0 ? "registeredDocumentsFront" : "registeredDocumentsBack",
//             "AADHAR CARD NO": imageIndex === 0 ? "aadharPhotoFront" : "aadharPhotoBack",
//             "PAN CARD NO": "panCard",
//             "Trade License": "tradeLicense",
//             "FSSI License": "fssaiLicense",
//             "Labour License": "labourLicense",
//             "Bank Details": "blankCheque",
//             "Passbook": "passbook",
//             "Company Name": "companyLogo",
//         };
//         return fieldMap[rowKey] || `image${imageIndex + 1}`;
//     };

//     const handleVerifyy = async (i) => {
//         const normalisedKey = rows[i].key.trim().replace(/\.$/, "");
//         const statusField = STATUS_FIELD_MAP[normalisedKey];

//         if (!statusField) {
//             console.warn("No status mapping for:", rows[i].key);
//             return;
//         }

//         const vendorId = getCurrentVendorId();
//         if (!vendorId) {
//             alert("Vendor ID is missing");
//             return;
//         }

//         if (vendorNotFound) {
//             alert("Vendor not registered. Cannot verify.");
//             return;
//         }

//         const token = localStorage.getItem("authToken");
//         if (!token) {
//             alert("Authorization token missing");
//             return;
//         }

//         try {
//             const vendorData = {
//                 ownerNameStatus: vendorDetails?.ownerNameStatus ?? false,
//                 businessPlanStatus: vendorDetails?.businessPlanStatus ?? false,
//                 registeredNameStatus: vendorDetails?.registeredNameStatus ?? false,
//                 registeredDocumentsStatus: vendorDetails?.registeredDocumentsStatus ?? false,
//                 mobileNumberStatus: vendorDetails?.mobileNumberStatus ?? false,
//                 emailStatus: vendorDetails?.emailStatus ?? false,
//                 aadharNumberStatus: vendorDetails?.aadharNumberStatus ?? false,
//                 panCardStatus: vendorDetails?.panCardStatus ?? false,
//                 websiteNameStatus: vendorDetails?.websiteNameStatus ?? false,
//                 gstNumberStatus: vendorDetails?.gstNumberStatus ?? false,
//                 tradeLicenseStatus: vendorDetails?.tradeLicenseStatus ?? false,
//                 fssaiLicenseStatus: vendorDetails?.fssaiLicenseStatus ?? false,
//                 labourLicenseStatus: vendorDetails?.labourLicenseStatus ?? false,
//                 blankChequeStatus: vendorDetails?.blankChequeStatus ?? false,
//                 passbookStatus: vendorDetails?.passbookStatus ?? false,
//                 addressStatus: vendorDetails?.addressStatus ?? false,
//                 orderTypeStatus: vendorDetails?.orderTypeStatus ?? false,
//                 businessVerticalStatus: vendorDetails?.businessVerticalStatus ?? false,
//                 ratingStatus: vendorDetails?.ratingStatus ?? false,
//                 [statusField]: true,
//             };

//             setVendorDetails((prev) => ({
//                 ...prev,
//                 [statusField]: true,
//             }));

//             await verifyVendorStatus(vendorId, vendorData, token);
//             await fetchVendorDetails(vendorId);
//             alert("Vendor data verified successfully!");

//         } catch (err) {
//             console.error("❌ Verify error:", err);
//             setVendorDetails((prev) => ({
//                 ...prev,
//                 [statusField]: false,
//             }));

//             if (err.response?.status === 500 && err.response?.data?.message === "vendorId not found") {
//                 alert("Vendor not registered. Cannot verify.");
//             } else if (err.response?.status === 404) {
//                 alert("Vendor not registered. Cannot verify.");
//             } else {
//                 alert(`Failed to update status: ${err.response?.data?.message || err.message}`);
//             }
//         }
//     };

//     const handleReject = async (i) => {
//         const normalisedKey = rows[i].key.trim().replace(/\.$/, "");
//         const statusField = STATUS_FIELD_MAP[normalisedKey];

//         if (!statusField) {
//             console.warn("No status mapping for:", rows[i].key);
//             return;
//         }

//         const vendorId = getCurrentVendorId();
//         if (!vendorId) {
//             alert("Vendor ID is missing – cannot update.");
//             return;
//         }

//         if (vendorNotFound) {
//             alert("Vendor not registered. Cannot reject.");
//             return;
//         }

//         const token = localStorage.getItem("authToken");
//         if (!token) {
//             alert("Authorization token missing. Please log in.");
//             return;
//         }

//         try {
//             const vendorData = {
//                 ownerNameStatus: vendorDetails?.ownerNameStatus ?? false,
//                 businessPlanStatus: vendorDetails?.businessPlanStatus ?? false,
//                 registeredNameStatus: vendorDetails?.registeredNameStatus ?? false,
//                 registeredDocumentsStatus: vendorDetails?.registeredDocumentsStatus ?? false,
//                 mobileNumberStatus: vendorDetails?.mobileNumberStatus ?? false,
//                 emailStatus: vendorDetails?.emailStatus ?? false,
//                 aadharNumberStatus: vendorDetails?.aadharNumberStatus ?? false,
//                 panCardStatus: vendorDetails?.panCardStatus ?? false,
//                 websiteNameStatus: vendorDetails?.websiteNameStatus ?? false,
//                 gstNumberStatus: vendorDetails?.gstNumberStatus ?? false,
//                 tradeLicenseStatus: vendorDetails?.tradeLicenseStatus ?? false,
//                 fssaiLicenseStatus: vendorDetails?.fssaiLicenseStatus ?? false,
//                 labourLicenseStatus: vendorDetails?.labourLicenseStatus ?? false,
//                 blankChequeStatus: vendorDetails?.blankChequeStatus ?? false,
//                 passbookStatus: vendorDetails?.passbookStatus ?? false,
//                 addressStatus: vendorDetails?.addressStatus ?? false,
//                 orderTypeStatus: vendorDetails?.orderTypeStatus ?? false,
//                 businessVerticalStatus: vendorDetails?.businessVerticalStatus ?? false,
//                 ratingStatus: vendorDetails?.ratingStatus ?? false,
//                 [statusField]: false,
//             };

//             setVendorDetails((prev) => ({
//                 ...prev,
//                 [statusField]: false,
//             }));

//             await verifyVendorStatus(vendorId, vendorData, token);
//             await fetchVendorDetails(vendorId);
//             alert("Vendor status rejected successfully!");

//         } catch (err) {
//             console.error("❌ Reject error:", err);
//             setVendorDetails((prev) => ({
//                 ...prev,
//                 [statusField]: true,
//             }));

//             if (err.response?.status === 500 && err.response?.data?.message === "vendorId not found") {
//                 alert("Vendor not registered. Cannot reject.");
//             } else if (err.response?.status === 404) {
//                 alert("Vendor not registered. Cannot reject.");
//             } else {
//                 alert(`Failed to reject status: ${err.response?.data?.message || err.message}`);
//             }
//         }
//     };

//     // Fetch subscriptions from new API endpoint
//     useEffect(() => {
//         const token = localStorage.getItem("authToken");

//         const fetchData = async () => {
//             showLoader();

//             try {
//                 const data = await getAllEnquiries(token);
//                 const subscriptions = Array.isArray(data) ? data : [];

//                 const filtered = subscriptions.filter(
//                     (item) =>
//                         item.businessVerticals &&
//                         item.businessVerticals.includes("FOOD_AND_BEVERAGES") &&
//                         (item.parentId === null || item.parentId === 0 || item.parentId === undefined)
//                 );

//                 setRolesData(filtered);
//                 setFilteredData(filtered);

//                 if (filtered.length > 0) {
//                     const vendor = filtered[0];
//                     const vendorId = vendor?.vendorId;
//                     const parentId = vendor?.parentId;

//                     if (vendorId && (parentId === null || parentId === 0 || parentId === undefined)) {
//                         fetchVendorDetails(vendorId);
//                     }
//                 }

//             } catch (err) {
//                 console.error("Payment fetch error:", err);
//             } finally {
//                 hideLoader();
//             }
//         };

//         fetchData();
//     }, []);

//     // Apply filters
//     useEffect(() => {
//         let result = rolesData;

//         if (cityFilter) {
//             result = result.filter(item => item.city === cityFilter);
//         }

//         if (businessVerticalFilter) {
//             result = result.filter(item => item.businessVertical === businessVerticalFilter);
//         }

//         if (searchQuery.trim()) {
//             const query = searchQuery.toLowerCase().trim();
//             result = result.filter(item => {
//                 let fieldValue;

//                 if (searchType === "vendorId") {
//                     fieldValue = item.vendorId;
//                 } else if (searchType === "phoneNumber") {
//                     fieldValue = item.customerMobile;
//                 } else if (searchType === "email") {
//                     fieldValue = item.email || item.customerEmail;
//                 } else if (searchType === "name") {
//                     fieldValue = item.customerName;
//                 } else if (searchType === "city") {
//                     fieldValue = item.city;
//                 } else if (searchType === "businessVertical") {
//                     fieldValue = item.businessVertical;
//                 } else {
//                     fieldValue = item[searchType];
//                 }

//                 if (!fieldValue) return false;

//                 if (searchType === "phoneNumber") {
//                     const cleanPartnerMobile = fieldValue.toString().replace(/\D/g, '');
//                     const cleanQuery = query.replace(/\D/g, '');
//                     return fieldValue.toString().toLowerCase().includes(query) ||
//                         cleanPartnerMobile.includes(cleanQuery);
//                 }

//                 return fieldValue.toString().toLowerCase().includes(query);
//             });
//         }

//         setFilteredData(result);
//     }, [rolesData, cityFilter, businessVerticalFilter, searchType, searchQuery]);

//     const uniqueCities = useMemo(() => {
//         const cities = rolesData.map(item => item.city).filter(Boolean);
//         return [...new Set(cities)].sort();
//     }, [rolesData]);

//     const uniqueBusinessVerticals = useMemo(() => {
//         const verticals = rolesData.map(item => item.businessVertical).filter(Boolean);
//         return [...new Set(verticals)].sort();
//     }, [rolesData]);

//     const clearAllFilters = () => {
//         setSearchQuery("");
//         setCityFilter("");
//         setBusinessVerticalFilter("");
//         setSearchType("vendorId");
//     };

//     const getPlaceholderText = () => {
//         switch (searchType) {
//             case "vendorId": return "Search by Vendor ID...";
//             case "name": return "Search by Customer Name...";
//             case "email": return "Search by Email...";
//             case "phoneNumber": return "Search by Mobile...";
//             case "city": return "Search by City...";
//             case "businessVertical": return "Search by Business Vertical...";
//             default: return "Search...";
//         }
//     };

//     const searchOptions = [
//         { value: "vendorId", label: "Vendor ID" },
//         { value: "name", label: "Customer Name" },
//         { value: "createdAt", label: "Date" },
//         { value: "email", label: "Email" },
//         { value: "phoneNumber", label: "Mobile Number" },
//         { value: "city", label: "City" },
//         { value: "businessVertical", label: "Business Vertical" }
//     ];

//     useEffect(() => {
//         if (!selectedClient) {
//             setRows(getDefaultClientDetailsRows());
//             setVerifiedRows([]);
//             setRejectedRows([]);
//             setIsApproved(false);
//             setImageLoadErrors(new Set());
//             return;
//         }

//         const merged = { ...selectedClient, ...(vendorDetails || {}) };

//         const imageMap = {
//             "Register Documents": [
//                 normalizeImageUrl(merged.registeredDocumentsFront),
//                 normalizeImageUrl(merged.registeredDocumentsBack)
//             ].filter(url => url),
//             "AADHAR CARD NO": [
//                 normalizeImageUrl(merged.aadharPhotoFront),
//                 normalizeImageUrl(merged.aadharPhotoBack)
//             ].filter(url => url),
//             "PAN CARD NO": [normalizeImageUrl(merged.panCard)].filter(url => url),
//             "Trade License": [normalizeImageUrl(merged.tradeLicense)].filter(url => url),
//             "FSSI License": [normalizeImageUrl(merged.fssaiLicense)].filter(url => url),
//             "Labour License": [normalizeImageUrl(merged.labourLicense)].filter(url => url),
//             "Bank Details": [normalizeImageUrl(merged.blankCheque)].filter(url => url),
//             "Passbook": [normalizeImageUrl(merged.passbook)].filter(url => url),
//             "Company Name": [normalizeImageUrl(merged.companyLogo)].filter(url => url),
//         };

//         const newRows = [
//             { key: "Owner Name", value: merged.ownerName || "N/A" },
//             { key: "Company Name", value: merged.registeredName || "N/A" },
//             { key: "Business Plan", value: merged.businessPlan || "N/A" },
//             { key: "Position", value: merged.position || "N/A" },
//             { key: "Branding", value: merged.brandName || "N/A" },
//             { key: "Business Vertical", value: merged.businessVertical || "N/A" },
//             {
//                 key: "Order Type",
//                 value: Array.isArray(merged.orderTypes)
//                     ? merged.orderTypes
//                     : typeof merged.orderTypes === "string" && merged.orderTypes !== "N/A"
//                         ? merged.orderTypes.split(",").map(v => v.trim())
//                         : [],
//             },
//             { key: "Website", value: merged.websiteName || "N/A" },
//             { key: "Phone No", value: merged.mobileNumber || merged.customerMobile || "N/A" },
//             { key: "Email ID", value: merged.email || merged.customerEmail || "N/A" },
//             { key: "City", value: merged.city || "N/A" },
//             {
//                 key: "Address",
//                 value: {
//                     doorNo: merged.doorNumber || "N/A",
//                     street: merged.addressLine || "N/A",
//                     city: merged.city || "N/A",
//                     state: merged.state || "N/A",
//                     pincode: merged.pincode || "N/A",
//                     landmark: merged.landMark || "N/A",
//                     latitude: merged.latitude?.toString() || "N/A",
//                     longitude: merged.longitude?.toString() || "N/A",
//                 },
//             },
//             { key: "Register Documents", value: "Registered Documents" },
//             { key: "AADHAR CARD NO", value: merged.aadharNumber || "N/A" },
//             { key: "PAN CARD NO", value: merged.panCardNumber || "N/A" },
//             { key: "Trade License Number", value: merged.tradeLicenseNumber || "N/A" },
//             {
//                 key: "Trade License",
//                 value: {
//                     startDate: merged.tradeLicenseStartDate || "N/A",
//                     endDate: merged.tradeLicenseEndDate || "N/A",
//                 },
//             },
//             { key: "FSSAI License Number", value: merged.fssaiLicenseNumber || "N/A" },
//             {
//                 key: "FSSI License",
//                 value: {
//                     startDate: merged.fssaiStartDate || "N/A",
//                     endDate: merged.fssaiEndDate || "N/A",
//                 },
//             },
//             { key: "Labour License Number", value: merged.labourLicenseNumber || "N/A" },
//             {
//                 key: "Labour License",
//                 value: {
//                     startDate: merged.labourStartDate || "N/A",
//                     endDate: merged.labourEndDate || "N/A",
//                 },
//             },
//             { key: "GST No.", value: merged.gstNumber || "N/A" },
//             {
//                 key: "Bank Details",
//                 value: {
//                     holderName: merged.holderName || merged.accountHolderName || "N/A",
//                     branchName: merged.branchName || merged.bankName || "N/A",
//                     accountNumber: merged.accountNumber || merged.accountNo || "N/A",
//                     ifscCode: merged.ifscCode || "N/A",
//                 },
//             },
//             { key: "Passbook", value: "Passbook Image" },
//             { key: "Rating", value: merged.rating || 0 },
//             { key: "Selected Modules", value: merged.selectedModules?.join(", ") || "N/A" },
//             { key: "Remaining Days", value: merged.remainingDays ? `${merged.remainingDays} days` : "N/A" },
//         ];

//         const updatedRows = newRows.map((row) => ({
//             ...row,
//             images: imageMap[row.key] || [],
//         }));

//         setRows(updatedRows.map((r) => ({ ...r, isEditing: false })));
//         setVerifiedRows([]);
//         setRejectedRows([]);
//         setIsApproved(false);
//         setImageLoadErrors(new Set());
//     }, [selectedClient, vendorDetails]);

//     const handleViewClick = (client) => {
//         setSelectedClient(client);
//         const vendorId = client?.vendorId;
//         setVendorNotFound(false);
//         setVendorError(null);
//         fetchVendorDetails(vendorId);
//     };

//     const handleBackClick = () => {
//         setSelectedClient(null);
//         setVendorNotFound(false);
//         setVendorError(null);
//     };

//     const handleFileChange = (e, index) => {
//         const fileName = e.target.files[0]?.name || "";
//         const updated = [...rows];
//         updated[index].value = fileName;
//         setRows(updated);
//     };

//     // Clean Image Display Component
//     const ImageDisplay = ({ images, fieldName }) => {
//         if (!images || images.length === 0) {
//             return (
//                 <div className="text-center">
//                     <span style={{ fontSize: "18px", color: "#6c757d" }}>—</span>
//                 </div>
//             );
//         }

//         return (
//             <div className="d-flex justify-content-center gap-2 flex-wrap">
//                 {images.map((img, idx) => {
//                     const imageUrl = typeof img === 'string' ? img : img.url;
//                     const hasFailed = isImageFailed(fieldName, idx);

//                     if (hasFailed || !imageUrl) {
//                         return (
//                             <div key={idx} className="text-center">
//                                 <span style={{ fontSize: "18px", color: "#6c757d" }}>—</span>
//                             </div>
//                         );
//                     }

//                     return (
//                         <div key={idx} className="text-center position-relative">
//                             <img
//                                 src={imageUrl}
//                                 alt={`${fieldName}-${idx}`}
//                                 style={{
//                                     width: fieldName === "Company Name" ? "80px" : "60px",
//                                     height: fieldName === "Company Name" ? "80px" : "60px",
//                                     borderRadius: "8px",
//                                     objectFit: "cover",
//                                     border: "2px solid #e2e8f0",
//                                     transition: "transform 0.2s ease"
//                                 }}
//                                 onError={() => handleImageError(imageUrl, fieldName, idx)}
//                                 onLoad={() => handleImageLoad(imageUrl, fieldName, idx)}
//                             />
//                         </div>
//                     );
//                 })}
//             </div>
//         );
//     };

//     return (
//         <div style={styles.container}>
//             {!selectedClient ? (
//                 <>
//                     {/* Header */}
//                     {/* <div style={styles.header}>
//                         <div style={styles.title}>
//                             🍽️ Paid Food Vendors
//                             <span style={styles.titleBadge}>{filteredData.length}</span>
//                         </div>
//                         <div>
//                             <button
//                                 onClick={() => window.location.reload()}
//                                 style={{ ...styles.button, ...styles.buttonPrimary }}
//                             >
//                                 <Icons.Refresh /> Refresh
//                             </button>
//                         </div>
//                     </div> */}

//                     {/* Filters */}
//                     <div style={styles.filtersContainer}>
//                         <div style={styles.searchGroup}>
//                             <select
//                                 value={searchType}
//                                 onChange={(e) => setSearchType(e.target.value)}
//                                 style={styles.select}
//                             >
//                                 {searchOptions.map(option => (
//                                     <option key={option.value} value={option.value}>
//                                         {option.label}
//                                     </option>
//                                 ))}
//                             </select>

//                             <input
//                                 type="text"
//                                 placeholder={getPlaceholderText()}
//                                 value={searchQuery}
//                                 onChange={(e) => setSearchQuery(e.target.value)}
//                                 style={{
//                                     ...styles.input,
//                                     borderColor: searchQuery ? 'rgb(230 109 51)' : '#e2e8f0'
//                                 }}
//                             />
//                         </div>

//                         <select
//                             value={cityFilter}
//                             onChange={(e) => setCityFilter(e.target.value)}
//                             style={{ ...styles.select, minWidth: '110px' }}
//                         >
//                             <option value="">All Cities</option>
//                             {uniqueCities.map(city => (
//                                 <option key={city} value={city}>{city}</option>
//                             ))}
//                         </select>

//                         <button
//                             onClick={clearAllFilters}
//                             style={{ ...styles.button, ...styles.buttonSecondary }}
//                         >
//                             <Icons.Clear /> Clear
//                         </button>

//                         {(searchQuery || cityFilter || businessVerticalFilter) && (
//                             <span style={{ fontSize: '12px', color: '#718096' }}>
//                                 <strong>{filteredData.length}</strong> result{filteredData.length !== 1 && 's'}
//                             </span>
//                         )}
//                     </div>

//                     {/* Table */}
//                     <div style={styles.tableWrapper}>
//                         <table style={styles.table}>
//                             <thead style={styles.thead}>
//                                 <tr>
//                                     <th style={{ ...styles.th, width: '50px', textAlign: 'center' }}>#</th>
//                                     <th style={styles.th}>Date</th>
//                                     <th style={styles.th}>Customer</th>
//                                     <th style={styles.th}>Restaurant</th>
//                                     <th style={styles.th}>Email</th>
//                                     <th style={styles.th}>Mobile</th>
//                                     <th style={styles.th}>City</th>
//                                     <th style={styles.th}>Vendor ID</th>
//                                     <th style={styles.th}>States</th>
//                                     <th style={{ ...styles.th, textAlign: 'center', width: '80px' }}>Action</th>
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 {filteredData.length ? (
//                                     filteredData.map((c, idx) => (
//                                         <tr
//                                             key={c.subscriptionId || idx}
//                                             style={{
//                                                 backgroundColor: idx % 2 === 0 ? '#ffffff' : '#fafbfc',
//                                                 transition: 'background 0.15s ease'
//                                             }}
//                                             onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f0f4ff'}
//                                             onMouseLeave={(e) => e.currentTarget.style.backgroundColor = idx % 2 === 0 ? '#ffffff' : '#fafbfc'}
//                                         >
//                                             <td style={{ ...styles.td, textAlign: 'center', color: '#a0aec0' }}>{idx + 1}</td>
//                                             <td style={styles.td}>{formatDate(c?.registerTime)}</td>
//                                             <td style={{ ...styles.td, fontWeight: '500' }}>{c?.name || "—"}</td>
//                                             <td style={styles.td}>{c?.registeredName || c?.companyName || "—"}</td>
//                                             <td style={{ ...styles.td, color: '#4a5568' }}>{c?.email || c?.customerEmail || "—"}</td>
//                                             <td style={styles.td}>{c?.mobileNumber || "—"}</td>
//                                             <td style={styles.td}>{c?.city || "—"}</td>
//                                             <td style={styles.td}>{c?.vendorId || "—"}</td>
//                                             <td style ={styles.td}>{c?.states || "_" }</td>
//                                             <td style={{ ...styles.td, textAlign: 'center' }}>
//                                                 <button
//                                                     style={{
//                                                         ...styles.button,
//                                                         ...styles.buttonPrimary,
//                                                         padding: '4px 14px',
//                                                         height: '32px',
//                                                         fontSize: '12px'
//                                                     }}
//                                                     onClick={() => handleViewClick(c)}
//                                                 >
//                                                     View
//                                                 </button>
//                                             </td>
//                                         </tr>
//                                     ))
//                                 ) : (
//                                     <tr>
//                                         <td colSpan="9" style={{ padding: 0 }}>
//                                             <div style={styles.emptyState}>
//                                                 <div style={{ fontSize: '40px', opacity: 0.5 }}>📋</div>
//                                                 <div style={styles.emptyStateText}>
//                                                     {rolesData.length === 0 ? 'Loading vendors...' : 'No vendors found'}
//                                                 </div>
//                                                 <div style={styles.emptyStateSubtext}>
//                                                     {rolesData.length === 0
//                                                         ? 'Please wait while we fetch the data'
//                                                         : (searchQuery.trim() || cityFilter || businessVerticalFilter)
//                                                             ? 'Try adjusting your filters to see more results'
//                                                             : 'No paid food vendors are available'}
//                                                 </div>
//                                             </div>
//                                         </td>
//                                     </tr>
//                                 )}
//                             </tbody>
//                         </table>
//                     </div>

//                     {/* Stats */}
//                     {/* <div style={styles.statsBar}>
//                         <span style={styles.statItem}>
//                             Total: <span style={styles.statNumber}>{rolesData.length}</span>
//                         </span>
//                         <span style={styles.statItem}>
//                             Showing: <span style={styles.statNumber}>{filteredData.length}</span>
//                         </span>
//                         {(searchQuery || cityFilter || businessVerticalFilter) && (
//                             <span style={{ color: 'rgb(230 109 51)', fontSize: '11px' }}>
//                                 ⚡ Filtered results
//                             </span>
//                         )}
//                     </div> */}
//                 </>
//             ) : (
//                 /* ============ DETAIL VIEW ============ */
//                 <div>
//                     {/* Detail Header */}
//                     <div style={styles.detailHeader}>
//                         <button
//                             onClick={handleBackClick}
//                             style={{ ...styles.button, ...styles.buttonPrimary }}
//                         >
//                             <Icons.Back /> Back
//                         </button>
//                         <div style={styles.detailTitle}>
//                             Vendor Details — <span style={{ color: 'rgb(230 109 51)' }}>
//                                 {selectedClient?.registeredName || selectedClient?.name || 'N/A'}
//                             </span>
//                         </div>
//                         {vendorDetails?.approvalStatus ? (
//                             <span style={{ ...styles.statusBadge, ...styles.verifiedBadge }}>
//                                 <Icons.Approved /> Approved
//                             </span>
//                         ) : (
//                             <button
//                                 style={{ ...styles.button, ...styles.buttonSuccess }}
//                                 onClick={handleApproveAll}
//                             >
//                                 <Icons.Check /> Approve
//                             </button>
//                         )}
//                     </div>

//                     {loading && (
//                         <div className="text-center my-5">
//                             <div className="spinner-border text-primary" role="status">
//                                 <span className="visually-hidden">Loading...</span>
//                             </div>
//                         </div>
//                     )}

//                     {!loading && vendorNotFound && (
//                         <div style={styles.emptyState}>
//                             <div style={{ fontSize: '48px' }}>⚠️</div>
//                             <div style={{ ...styles.emptyStateText, color: '#dc3545' }}>
//                                 Vendor Not Registered
//                             </div>
//                             <div style={styles.emptyStateSubtext}>
//                                 This vendor has a subscription but is not registered in the system.
//                                 <br />
//                                 Vendor ID: <strong>{selectedClient?.vendorId}</strong>
//                             </div>
//                         </div>
//                     )}

//                     {!loading && !vendorNotFound && vendorDetails && (
//                         <div style={styles.detailTableWrapper}>
//                             <table style={styles.detailTable}>
//                                 <thead>
//                                     <tr>
//                                         <th style={styles.detailTh}>Field</th>
//                                         <th style={styles.detailTh}>Value</th>
//                                         <th style={styles.detailTh}>Image</th>
//                                         <th style={styles.detailTh}>Status</th>
//                                     </tr>
//                                 </thead>
//                                 <tbody>
//                                     {rows.map((r, i) => {
//                                         const isEditing = r.isEditing || false;

//                                         const handleInputChange = (field, value) => {
//                                             setRows((prevRows) =>
//                                                 prevRows.map((row, idx) =>
//                                                     idx === i
//                                                         ? {
//                                                             ...row,
//                                                             value:
//                                                                 typeof row.value === "object"
//                                                                     ? { ...row.value, [field]: value }
//                                                                     : value,
//                                                         }
//                                                         : row
//                                                 )
//                                             );
//                                         };

//                                         const handleOrderTypeChange = (selectedValue) => {
//                                             setRows((prevRows) =>
//                                                 prevRows.map((row, idx) => {
//                                                     if (idx === i) {
//                                                         const currentValues = Array.isArray(row.value) ? row.value : [];
//                                                         const isSelected = currentValues.includes(selectedValue);

//                                                         if (isSelected) {
//                                                             return {
//                                                                 ...row,
//                                                                 value: currentValues.filter(v => v !== selectedValue)
//                                                             };
//                                                         } else {
//                                                             return {
//                                                                 ...row,
//                                                                 value: [...currentValues, selectedValue]
//                                                             };
//                                                         }
//                                                     }
//                                                     return row;
//                                                 })
//                                             );
//                                         };

//                                         const handleBusinessPlanChange = (selectedValue) => {
//                                             setRows((prevRows) =>
//                                                 prevRows.map((row, idx) =>
//                                                     idx === i
//                                                         ? { ...row, value: selectedValue }
//                                                         : row
//                                                 )
//                                             );
//                                         };

//                                         const handleRatingChange = (selectedValue) => {
//                                             setRows((prevRows) =>
//                                                 prevRows.map((row, idx) =>
//                                                     idx === i
//                                                         ? { ...row, value: parseFloat(selectedValue) }
//                                                         : row
//                                                 )
//                                             );
//                                         };

//                                         const handleImageChange = (e) => {
//                                             const files = Array.from(e.target.files);
//                                             const newImages = files.map((file) => ({
//                                                 url: URL.createObjectURL(file),
//                                                 file
//                                             }));

//                                             setRows(prev =>
//                                                 prev.map((row, idx) =>
//                                                     idx === i
//                                                         ? { ...row, images: [...(row.images || []), ...newImages] }
//                                                         : row
//                                                 )
//                                             );
//                                         };

//                                         const isEditableField = ![
//                                             "Selected Modules",
//                                             "Remaining Days",
//                                             "Business Vertical",
//                                             "City"
//                                         ].includes(r.key);

//                                         return (
//                                             <tr key={r.key || i}>
//                                                 <td style={{ ...styles.detailTd, fontWeight: '600' }}>{r.key}</td>

//                                                 <td style={styles.detailTd}>
//                                                     {r.key === "Order Type" ? (
//                                                         isEditing ? (
//                                                             <div className="d-flex flex-column gap-1">
//                                                                 {orderTypeOptions.map((option) => {
//                                                                     const currentValues = Array.isArray(r.value) ? r.value : [];
//                                                                     const isSelected = currentValues.includes(option);
//                                                                     return (
//                                                                         <div key={option} className="form-check">
//                                                                             <input
//                                                                                 className="form-check-input"
//                                                                                 type="checkbox"
//                                                                                 id={`order-type-${option}-${i}`}
//                                                                                 checked={isSelected}
//                                                                                 onChange={() => handleOrderTypeChange(option)}
//                                                                             />
//                                                                             <label className="form-check-label" htmlFor={`order-type-${option}-${i}`}>
//                                                                                 {option}
//                                                                             </label>
//                                                                         </div>
//                                                                     );
//                                                                 })}
//                                                             </div>
//                                                         ) : (
//                                                             Array.isArray(r.value) && r.value.length > 0
//                                                                 ? r.value.join(", ")
//                                                                 : "N/A"
//                                                         )
//                                                     ) : r.key === "Business Plan" ? (
//                                                         isEditing && isEditableField ? (
//                                                             <select
//                                                                 value={r.value || ""}
//                                                                 onChange={(e) => handleBusinessPlanChange(e.target.value)}
//                                                                 className="form-select"
//                                                             >
//                                                                 <option value="">Select Business Plan</option>
//                                                                 {businessPlanOptions.map((option) => (
//                                                                     <option key={option} value={option}>{option}</option>
//                                                                 ))}
//                                                             </select>
//                                                         ) : (
//                                                             r.value || "N/A"
//                                                         )
//                                                     ) : r.key === "Rating" ? (
//                                                         isEditing && isEditableField ? (
//                                                             <select
//                                                                 value={r.value || 0}
//                                                                 onChange={(e) => handleRatingChange(e.target.value)}
//                                                                 className="form-select"
//                                                             >
//                                                                 {ratingOptions.map((option) => (
//                                                                     <option key={option.value} value={option.value}>
//                                                                         {option.label}
//                                                                     </option>
//                                                                 ))}
//                                                             </select>
//                                                         ) : (
//                                                             <div>{r.value || 0} {r.value ? "★" : ""}</div>
//                                                         )
//                                                     ) : r.key === "Company Name" ? (
//                                                         <div>
//                                                             {isEditing && isEditableField ? (
//                                                                 <input
//                                                                     type="text"
//                                                                     value={r.value || ""}
//                                                                     onChange={(e) => handleInputChange("value", e.target.value)}
//                                                                     className="form-control mb-1"
//                                                                 />
//                                                             ) : (
//                                                                 r.value || "N/A"
//                                                             )}
//                                                         </div>
//                                                     ) : r.key === "Bank Details" ? (
//                                                         ["holderName", "branchName", "accountNumber", "ifscCode"].map((field) => (
//                                                             <div key={field} className="mb-1">
//                                                                 <strong>{field.replace(/([A-Z])/g, " $1")}:</strong>{" "}
//                                                                 {isEditing && isEditableField ? (
//                                                                     <input
//                                                                         type="text"
//                                                                         value={r.value?.[field] || ""}
//                                                                         onChange={(e) => handleInputChange(field, e.target.value)}
//                                                                         className="form-control d-inline-block w-75"
//                                                                     />
//                                                                 ) : (
//                                                                     r.value?.[field] || "N/A"
//                                                                 )}
//                                                             </div>
//                                                         ))
//                                                     ) : r.key === "Address" ? (
//                                                         ["doorNo", "street", "city", "state", "pincode", "landmark", "latitude", "longitude"].map((field) => (
//                                                             <div key={field} className="mb-1">
//                                                                 <strong>{field.charAt(0).toUpperCase() + field.slice(1)}:</strong>{" "}
//                                                                 {isEditing && isEditableField ? (
//                                                                     <input
//                                                                         type="text"
//                                                                         value={r.value?.[field] || ""}
//                                                                         onChange={(e) => handleInputChange(field, e.target.value)}
//                                                                         className="form-control d-inline-block w-75"
//                                                                     />
//                                                                 ) : (
//                                                                     r.value?.[field] || "N/A"
//                                                                 )}
//                                                             </div>
//                                                         ))
//                                                     ) : r.key === "Trade License" ||
//                                                         r.key === "FSSI License" ||
//                                                         r.key === "Labour License" ? (
//                                                         <>
//                                                             <div className="mb-1">
//                                                                 <strong>Start Date:</strong>{" "}
//                                                                 {isEditing && isEditableField ? (
//                                                                     <input
//                                                                         type="date"
//                                                                         value={safeDateToISOString(r.value?.startDate)}
//                                                                         onChange={(e) => handleInputChange("startDate", e.target.value)}
//                                                                         className="form-control d-inline-block w-75"
//                                                                     />
//                                                                 ) : (
//                                                                     safeDateDisplay(r.value?.startDate)
//                                                                 )}
//                                                             </div>
//                                                             <div>
//                                                                 <strong>End Date:</strong>{" "}
//                                                                 {isEditing && isEditableField ? (
//                                                                     <input
//                                                                         type="date"
//                                                                         value={safeDateToISOString(r.value?.endDate)}
//                                                                         onChange={(e) => handleInputChange("endDate", e.target.value)}
//                                                                         className="form-control d-inline-block w-75"
//                                                                     />
//                                                                 ) : (
//                                                                     safeDateDisplay(r.value?.endDate)
//                                                                 )}
//                                                             </div>
//                                                         </>
//                                                     ) : r.key === "Trade License Number" ||
//                                                         r.key === "Labour License Number" ||
//                                                         r.key === "FSSAI License Number" ||
//                                                         r.key === "Owner Name" ||
//                                                         r.key === "Position" ||
//                                                         r.key === "BrandName" ||
//                                                         r.key === "Phone No" ||
//                                                         r.key === "Email ID" ||
//                                                         r.key === "Website" ||
//                                                         r.key === "GST No." ||
//                                                         r.key === "AADHAR CARD NO" ||
//                                                         r.key === "PAN CARD NO" ? (
//                                                         isEditing && isEditableField ? (
//                                                             <input
//                                                                 type="text"
//                                                                 value={r.value || ""}
//                                                                 onChange={(e) => handleInputChange("value", e.target.value)}
//                                                                 className="form-control"
//                                                             />
//                                                         ) : (
//                                                             r.value || "N/A"
//                                                         )
//                                                     ) : r.key === "Register Documents" ? (
//                                                         "Registered Documents"
//                                                     ) : r.key === "Passbook" ? (
//                                                         "Passbook Image"
//                                                     ) : (
//                                                         r.value || "N/A"
//                                                     )}
//                                                 </td>

//                                                 <td style={{ ...styles.detailTd, textAlign: 'center' }}>
//                                                     {isEditing && isEditableField ? (
//                                                         <>
//                                                             {(r.key === "Company Name" || r.key === "Register Documents" ||
//                                                                 r.key === "AADHAR CARD NO" || r.key === "PAN CARD NO" ||
//                                                                 r.key === "Trade License" || r.key === "FSSI License" ||
//                                                                 r.key === "Labour License" || r.key === "Bank Details" ||
//                                                                 r.key === "Passbook") && (
//                                                                     <input
//                                                                         type="file"
//                                                                         multiple={r.key === "Register Documents" || r.key === "AADHAR CARD NO"}
//                                                                         accept="image/*"
//                                                                         onChange={handleImageChange}
//                                                                         className="form-control mb-2"
//                                                                     />
//                                                                 )}
//                                                             <ImageDisplay images={r.images} fieldName={r.key} />
//                                                         </>
//                                                     ) : (
//                                                         <ImageDisplay images={r.images} fieldName={r.key} />
//                                                     )}
//                                                 </td>

//                                                 <td style={{ ...styles.detailTd, textAlign: 'center' }}>
//                                                     {isEditing && isEditableField ? (
//                                                         <div className="d-flex flex-wrap gap-2 justify-content-center">
//                                                             <button
//                                                                 className="btn btn-sm btn-success"
//                                                                 onClick={() => handleSaveRow(i)}
//                                                                 style={{ minWidth: 70 }}
//                                                             >
//                                                                 <Icons.Save /> Save
//                                                             </button>
//                                                             <button
//                                                                 className="btn btn-sm btn-secondary"
//                                                                 onClick={() =>
//                                                                     setRows((prev) =>
//                                                                         prev.map((row, idx) =>
//                                                                             idx === i ? { ...row, isEditing: false } : row
//                                                                         )
//                                                                     )
//                                                                 }
//                                                                 style={{ minWidth: 70 }}
//                                                             >
//                                                                 Cancel
//                                                             </button>
//                                                         </div>
//                                                     ) : (
//                                                         <div className="d-flex flex-wrap gap-2 justify-content-center">
//                                                             {isFieldVerified(r.key, r.value, vendorDetails, r.images) ? (
//                                                                 <span style={{ ...styles.statusBadge, ...styles.verifiedBadge }}>
//                                                                     <Icons.Check /> Verified
//                                                                 </span>
//                                                             ) : (
//                                                                 <button
//                                                                     className="btn btn-sm btn-warning"
//                                                                     onClick={() => handleVerifyy(i)}
//                                                                     disabled={!canVerifyField(r.key, r.value, vendorDetails, r.images) || !isEditableField}
//                                                                     style={{ minWidth: 70 }}
//                                                                 >
//                                                                     Verify
//                                                                 </button>
//                                                             )}

//                                                             {isFieldRejected(r.key, vendorDetails) ? (
//                                                                 <span style={{ ...styles.statusBadge, ...styles.rejectedBadge }}>
//                                                                     <Icons.X /> Rejected
//                                                                 </span>
//                                                             ) : (
//                                                                 <button
//                                                                     className="btn btn-sm btn-secondary"
//                                                                     onClick={() => handleReject(i)}
//                                                                     disabled={
//                                                                         r.key === "Rating" ? true :
//                                                                             !hasValidData({ key: r.key, value: r.value, images: r.images }, vendorDetails) ||
//                                                                             !isEditableField
//                                                                     }
//                                                                     style={{ minWidth: 70 }}
//                                                                 >
//                                                                     Reject
//                                                                 </button>
//                                                             )}

//                                                             {isEditableField && (
//                                                                 <button
//                                                                     className="btn btn-sm btn-primary"
//                                                                     onClick={() =>
//                                                                         setRows((prev) =>
//                                                                             prev.map((row, idx) =>
//                                                                                 idx === i ? { ...row, isEditing: true } : row
//                                                                             )
//                                                                         )
//                                                                     }
//                                                                     style={{ minWidth: 70 }}
//                                                                 >
//                                                                     <Icons.Edit /> Edit
//                                                                 </button>
//                                                             )}
//                                                         </div>
//                                                     )}
//                                                 </td>
//                                             </tr>
//                                         );
//                                     })}
//                                 </tbody>
//                             </table>
//                         </div>
//                     )}
//                 </div>
//             )}
//         </div>
//     );
// };

// export default FoodPaidClents;




import React, { useState, useEffect, useRef, useMemo } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { useLoader } from '../../../../context/LoaderProvider.jsx';
import {
    getVendorDetails,
    updateVendorDetails,
    getAllEnquiries,
    approveVendor,
    verifyVendorStatus
} from "../../../Servicefile/clientManagementService.jsx";

// ============================================
// PREMIUM ICONS COMPONENT
// ============================================
const Icons = {
    Search: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="11" cy="11" r="8" /><path d="M21 21l-4.35-4.35" />
        </svg>
    ),
    Refresh: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M23 4v6h-6M1 20v-6h6" />
            <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15" />
        </svg>
    ),
    Clear: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
        </svg>
    ),
    Back: () => (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polyline points="15 18 9 12 15 6" />
        </svg>
    ),
    Edit: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
            <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
        </svg>
    ),
    Check: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
            <polyline points="20 6 9 17 4 12" />
        </svg>
    ),
    X: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
        </svg>
    ),
    Save: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z" />
            <polyline points="17 21 17 13 7 13 7 21" />
            <polyline points="7 3 7 8 15 8" />
        </svg>
    ),
    Upload: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
            <polyline points="17 8 12 3 7 8" />
            <line x1="12" y1="3" x2="12" y2="15" />
        </svg>
    ),
    Approved: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#065f46" strokeWidth="2">
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
            <polyline points="22 4 12 14.01 9 11.01" />
        </svg>
    ),
    Pending: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#975a16" strokeWidth="2">
            <circle cx="12" cy="12" r="10" />
            <polyline points="12 6 12 12 16 14" />
        </svg>
    )
};

// ============================================
// PREMIUM STYLES
// ============================================
const styles = {
    container: {
        padding: '1px 6px',

        borderRadius: '16px',

        height: 'calc(100vh - 200px)',
        display: 'flex',
        flexDirection: 'column'
    },
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '0 0 16px 0',
        borderBottom: '2px solid #e9ecef',
        flexWrap: 'wrap',
        gap: '12px'
    },
    title: {
        fontSize: '20px',
        fontWeight: '600',
        color: '#2d3748',
        letterSpacing: '-0.3px',
        display: 'flex',
        alignItems: 'center',
        gap: '10px'
    },
    titleBadge: {
        background: 'rgb(230 109 51)',
        color: 'white',
        fontSize: '12px',
        fontWeight: '500',
        padding: '2px 12px',
        borderRadius: '12px',
        letterSpacing: '0.3px'
    },
    filtersContainer: {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: '10px',
        padding: '12px 0',
        borderBottom: '1px solid #edf2f7',
        marginBottom: '16px'
    },
    searchGroup: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        flex: '1 1 auto',
        minWidth: '280px'
    },
    select: {
        padding: '8px 12px',
        border: '1px solid #e2e8f0',
        borderRadius: '8px',
        background: 'white',
        fontSize: '13px',
        fontWeight: '500',
        color: '#2d3748',
        outline: 'none',
        transition: 'all 0.2s ease',
        height: '38px',
        minWidth: '140px',
        cursor: 'pointer'
    },
    input: {
        flex: '1',
        padding: '8px 14px',
        border: '1px solid #e2e8f0',
        borderRadius: '8px',
        fontSize: '13px',
        color: '#2d3748',
        outline: 'none',
        transition: 'all 0.2s ease',
        height: '38px',
        background: 'white',
        minWidth: '180px'
    },
    button: {
        padding: '8px 16px',
        borderRadius: '8px',
        border: 'none',
        fontWeight: '500',
        fontSize: '13px',
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        height: '38px',
        whiteSpace: 'nowrap'
    },
    buttonPrimary: {
        background: 'rgb(230 109 51)',
        color: 'white'
    },
    buttonSecondary: {
        background: '#e2e8f0',
        color: '#4a5568'
    },
    buttonSuccess: {
        background: '#48bb78',
        color: 'white'
    },
    buttonDanger: {
        background: '#fc8181',
        color: 'white'
    },
    buttonOutline: {
        background: 'transparent',
        border: '1px solid #e2e8f0',
        color: '#4a5568'
    },
    tableWrapper: {
        borderRadius: '10px',
        border: '1px solid #edf2f7',
        background: 'white',
        overflow: 'auto',
        maxHeight: '500px',
        scrollbarWidth: "none",
        position: 'relative'
    },
    table: {
        width: '100%',
        fontSize: '13px',
        borderCollapse: 'collapse',
        minWidth: '900px'
    },
    thead: {
        position: 'sticky',
        top: 0,
        zIndex: 10
    },
    th: {
        padding: '10px 12px',
        textAlign: 'center',
        fontWeight: '600',
        fontSize: '11px',
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
        color: 'white',
        background: '#e66d33',
        borderBottom: '2px solid #edf2f7',
        whiteSpace: 'nowrap'
    },
    td: {
        padding: '10px 12px',
        borderBottom: '1px solid #f1f5f9',
        color: '#2d3748',
        fontSize: '13px'
    },
    detailHeader: {
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        padding: '16px 0',
        borderBottom: '2px solid #e9ecef',
        marginBottom: '16px'
    },
    detailTitle: {
        fontSize: '18px',
        fontWeight: '600',
        color: '#2d3748',
        flex: 1
    },
    detailTableWrapper: {
        borderRadius: '10px',
        border: '1px solid #edf2f7',
        background: 'white',
        overflow: 'auto',
        maxHeight: '60vh'
    },
    detailTable: {
        width: '100%',
        fontSize: '13px',
        borderCollapse: 'collapse',
        minWidth: '700px'
    },
    detailTh: {
        padding: '10px 14px',
        textAlign: 'center',
        fontWeight: '600',
        fontSize: '11px',
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
        color: 'white',
        background: 'rgb(230 109 51)',
        border: '1px solid #dee2e6'
    },
    detailTd: {
        padding: '10px 14px',
        border: '1px solid #dee2e6',
        verticalAlign: 'middle',
        fontSize: '13px'
    },
    statusBadge: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: '4px',
        padding: '3px 12px',
        borderRadius: '20px',
        fontSize: '11px',
        fontWeight: '500',
        letterSpacing: '0.3px'
    },
    verifiedBadge: {
        background: '#c6f6d5',
        color: '#276749'
    },
    rejectedBadge: {
        background: '#fed7d7',
        color: '#9b2c2c'
    },
    pendingBadge: {
        background: '#fefcbf',
        color: '#975a16'
    },
    approvedBadge: {
        background: '#c6f6d5',
        color: '#276749'
    },
    pendingStatusBadge: {
        background: '#fefcbf',
        color: '#975a16'
    },
    emptyState: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '60px 20px',
        color: '#a0aec0'
    },
    emptyStateText: {
        marginTop: '16px',
        fontSize: '16px',
        fontWeight: '500',
        color: '#4a5568'
    },
    emptyStateSubtext: {
        fontSize: '13px',
        color: '#a0aec0',
        marginTop: '4px'
    },
    statsBar: {
        display: 'flex',
        alignItems: 'center',
        gap: '16px',
        padding: '8px 0 0 0',
        fontSize: '12px',
        color: '#718096'
    },
    statItem: {
        display: 'flex',
        alignItems: 'center',
        gap: '4px'
    },
    statNumber: {
        fontWeight: '600',
        color: '#2d3748'
    },
    approvalContainer: {
        display: 'flex',
        justifyContent: 'center',
        padding: '20px 0',
        marginTop: '16px',
        borderTop: '2px solid #e9ecef'
    }
};

// ============================================
// HELPER FUNCTIONS
// ============================================
const normalizeImageUrl = (url) => {
    if (!url || url === "N/A" || typeof url !== 'string') return null;
    if (url.startsWith('http')) return url;
    const cleanUrl = url.replace(/^\//, '');
    return `http://img.maamaas.com:8080/${cleanUrl}`;
};

const getDefaultClientDetailsRows = () => [
    { key: "Owner Name", value: "", isUpload: false },
    { key: "Business Plan", value: "", isUpload: false },
    { key: "Position", value: "", isUpload: false },
    { key: "Branding", value: "", isUpload: false },
    { key: "Company Name", value: "", isUpload: false },
    { key: "Register Documents", value: "", isUpload: true },
    { key: "Phone No", value: "", isUpload: false },
    { key: "Email ID", value: "", isUpload: false },
    {
        key: "Bank Details",
        value: {
            holderName: "",
            branchName: "",
            accountNumber: "",
            ifscCode: "",
        },
        isUpload: false,
    },
    { key: "Passbook", value: "", isUpload: true },
    { key: "AADHAR CARD NO", value: "", isUpload: false },
    { key: "PAN CARD NO", value: "", isUpload: false },
    { key: "Website", value: "", isUpload: false },
    { key: "GST No.", value: "", isUpload: false },
];

const STATUS_FIELD_MAP = {
    "Owner Name": "ownerNameStatus",
    "Business Plan": "businessPlanStatus",
    "Company Name": "registeredNameStatus",
    "Register Documents": "registeredDocumentsStatus",
    "Phone No": "mobileNumberStatus",
    "Email ID": "emailStatus",
    "AADHAR CARD NO": "aadharNumberStatus",
    "PAN CARD NO": "panCardStatus",
    "Website": "websiteNameStatus",
    "GST No.": "gstNumberStatus",
    "Trade License": "tradeLicenseStatus",
    "FSSI License": "fssaiLicenseStatus",
    "Labour License": "labourLicenseStatus",
    "Bank Details": "blankChequeStatus",
    "Passbook": "passbookStatus",
    "Address": "addressStatus",
    "Order Type": "orderTypeStatus",
    "Business Vertical": "businessVerticalStatus",
    "Rating": "ratingStatus",
    "Trade License Number": "tradeLicenseStatus",
    "FSSAI License Number": "fssaiLicenseStatus",
    "Labour License Number": "labourLicenseStatus",
};

const orderTypeOptions = ["DINE_IN", "TAKEAWAY", "DELIVERY", "TABLE_DINE_IN"];
const businessPlanOptions = ["HOTEL", "RESTAURANT", "CAFE", "CLOUD_KITCHEN", "FOOD_COURT", "STREET_FOOD", "BAKERY"];
const businessVerticalOptions = ["FOOD_AND_BEVERAGES", "CATERINGS_SERVICES", "LOGISTICS_SUPPLY", "FRESH_GROCERIES"];

const ratingOptions = [
    { value: 0, label: "0 - Not Rated" },
    { value: 1, label: "1 ★" },
    { value: 1.5, label: "1.5 ★" },
    { value: 2, label: "2 ★" },
    { value: 2.5, label: "2.5 ★" },
    { value: 3, label: "3 ★" },
    { value: 3.5, label: "3.5 ★" },
    { value: 4, label: "4 ★" },
    { value: 4.5, label: "4.5 ★" },
    { value: 5, label: "5 ★" }
];

const safeDateToISOString = (dateString) => {
    if (!dateString || dateString === "N/A" || dateString === "Invalid Date") return "";
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return "";
    return date.toISOString().split("T")[0];
};

const safeDateDisplay = (dateString) => {
    if (!dateString || dateString === "N/A" || dateString === "Invalid Date") return "N/A";
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return "N/A";
    return date.toLocaleDateString();
};

const hasValidData = (row, vendorDetails) => {
    if (!row) return false;
    const field = row.key;
    const value = row.value;

    if (Array.isArray(value)) {
        return value.length > 0 && value[0] !== "N/A";
    }

    if (typeof value === 'string') {
        return value && value !== "N/A" && value.trim() !== "";
    }

    if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
        if (field === "Address" || field === "Bank Details" ||
            field === "Trade License" || field === "FSSI License" || field === "Labour License") {
            return Object.values(value).some(val =>
                val && val !== "N/A" && val.toString().trim() !== ""
            );
        }
        return Object.keys(value).length > 0;
    }

    if (typeof value === 'number') {
        return value !== undefined && value !== null;
    }

    if (value === "Registered Documents" || value === "Passbook Image") {
        return row.images && row.images.length > 0;
    }

    return false;
};

const isFieldVerified = (rowKey, rowValue, vendorDetails, rowImages) => {
    const normalisedKey = rowKey.trim().replace(/\.$/, "");
    const statusField = STATUS_FIELD_MAP[normalisedKey];

    if (statusField && vendorDetails && vendorDetails[statusField] !== undefined) {
        return vendorDetails[statusField] === true;
    }

    const rowForValidation = { key: rowKey, value: rowValue, images: rowImages };

    const alwaysAutoVerifyFields = [
        "Business Vertical", "Order Type", "Address", "Rating",
        "Business Plan", "Position", "BrandName", "Website",
        "Phone No", "Email ID", "GST No.",
        "Trade License Number", "FSSAI License Number", "Labour License Number",
        "Owner Name", "Company Name", "AADHAR CARD NO", "PAN CARD NO"
    ];

    if (alwaysAutoVerifyFields.includes(rowKey)) {
        return hasValidData(rowForValidation, vendorDetails);
    }

    const documentFields = [
        "Register Documents", "Trade License", "FSSI License",
        "Labour License", "Bank Details", "Passbook"
    ];

    if (documentFields.includes(rowKey)) {
        return rowImages && rowImages.length > 0;
    }

    return false;
};

const isFieldRejected = (rowKey, vendorDetails) => {
    const normalisedKey = rowKey.trim().replace(/\.$/, "");
    const statusField = STATUS_FIELD_MAP[normalisedKey];
    if (!statusField || !vendorDetails) return false;
    return vendorDetails[statusField] === false;
};

const canVerifyField = (rowKey, rowValue, vendorDetails, rowImages) => {
    return hasValidData({ key: rowKey, value: rowValue, images: rowImages }, vendorDetails);
};

// ============================================
// MAIN COMPONENT
// ============================================
const FoodPaidClents = () => {
    /* -------- list‑screen state -------- */
    const [rolesData, setRolesData] = useState([]);
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    const { showLoader, hideLoader } = useLoader();

    // Filter states
    const [searchType, setSearchType] = useState("vendorId");
    const [searchQuery, setSearchQuery] = useState("");
    const [cityFilter, setCityFilter] = useState("");
    const [businessVerticalFilter, setBusinessVerticalFilter] = useState("");
    const [filteredData, setFilteredData] = useState([]);

    /* -------- detail‑screen state -------- */
    const [selectedClient, setSelectedClient] = useState(null);
    const [vendorDetails, setVendorDetails] = useState(null);
    const [vendorNotFound, setVendorNotFound] = useState(false);
    const [vendorError, setVendorError] = useState(null);
    const [loading, setLoading] = useState(false);

    const [rows, setRows] = useState(getDefaultClientDetailsRows());
    const [verifiedRows, setVerifiedRows] = useState([]);
    const [rejectedRows, setRejectedRows] = useState([]);
    const [isApproved, setIsApproved] = useState(false);
    const [imageLoadErrors, setImageLoadErrors] = useState(new Set());

    const fileInputRef = useRef(null);
    const [vendorData, setVendorData] = useState({});
    const [rowId, setRowId] = useState(null);

    // Screen resize effect
    useEffect(() => {
        const handleResize = () => setScreenWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const getCurrentVendorId = () => {
        return (
            selectedClient?.vendorId ||
            selectedClient?.vendorEnquiry?.vendorId ||
            vendorDetails?.vendorId ||
            null
        );
    };

    const handleApproveAll = async () => {
        try {
            const token = localStorage.getItem("authToken");
            const vendorId = getCurrentVendorId();

            if (!vendorId) return alert("Vendor ID not found ❌");

            const body = {
                approvalStatus: true,
                approvalRemarks: "Approved by admin"
            };

            const data = await approveVendor(vendorId, body, token);
            alert("Vendor Approved Successfully ✅");
            fetchVendorDetails(vendorId);

        } catch (error) {
            console.error("Approval Error:", error);
            alert("Approval Failed ❌");
        }
    };

    const vendorId = getCurrentVendorId();

    const handleImageError = (imageUrl, fieldName, index) => {
        const errorKey = `${fieldName}-${index}`;
        setImageLoadErrors(prev => new Set([...prev, errorKey]));
    };

    const handleImageLoad = (imageUrl, fieldName, index) => {
        const errorKey = `${fieldName}-${index}`;
        setImageLoadErrors(prev => {
            const newSet = new Set(prev);
            newSet.delete(errorKey);
            return newSet;
        });
    };

    const isImageFailed = (fieldName, index) => {
        return imageLoadErrors.has(`${fieldName}-${index}`);
    };

    const fetchVendorDetails = async (vendorId) => {
        if (!vendorId) return;
        setLoading(true);
        setVendorNotFound(false);
        setVendorError(null);

        const token = localStorage.getItem("authToken");

        try {
            const data = await getVendorDetails(vendorId, token);
            setVendorDetails(data);
            setVendorNotFound(false);
            setVendorError(null);
        } catch (err) {
            console.error("❌ get-vendor-details error:", err);
            if (err.response?.status === 500 && err.response?.data?.message === "vendorId not found") {
                setVendorNotFound(true);
                setVendorDetails(null);
                setVendorError("Vendor not registered");
            } else {
                setVendorError("Failed to fetch vendor details");
            }
        } finally {
            setLoading(false);
        }
    };

    const formatDate = (date) => {
        if (!date) return "—";
        const d = new Date(date);
        if (isNaN(d.getTime())) return "—";
        const day = String(d.getDate()).padStart(2, "0");
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const year = d.getFullYear();
        return `${day}-${month}-${year}`;
    };

    const handleSaveRow = async (rowIndex) => {
        const token = localStorage.getItem("authToken") || localStorage.getItem("token");

        if (!token) {
            alert("No authentication token found");
            return;
        }

        try {
            const vendorId = getCurrentVendorId();
            if (!vendorId) {
                alert("Vendor ID not found");
                return;
            }

            const row = rows[rowIndex];
            const formData = new FormData();
            const vendorData = {};

            const fieldMapping = {
                "Owner Name": "ownerName",
                "Phone No": "mobileNumber",
                "Position": "position",
                "Branding": "brandName",
                "Website": "websiteName",
                "Email ID": "email",
                "Company Name": "registeredName",
                "AADHAR CARD NO": "aadharNumber",
                "PAN CARD NO": "panCardNumber",
                "GST No.": "gstNumber",
                "Order Type": "orderTypes",
                "Business Plan": "businessPlan",
                "Trade License Number": "tradeLicenseNumber",
                "FSSAI License Number": "fssaiLicenseNumber",
                "Labour License Number": "labourLicenseNumber",
                "Rating": "rating"
            };

            const backendFieldName = fieldMapping[row.key];

            if (backendFieldName && row.value) {
                if (row.key === "Order Type") {
                    vendorData[backendFieldName] = Array.isArray(row.value) ? row.value : [row.value];
                } else if (row.key === "Rating") {
                    vendorData[backendFieldName] = parseFloat(row.value) || 0;
                } else if (row.value !== "N/A") {
                    vendorData[backendFieldName] = row.value;
                }
            }

            if (row.key === "Address" && typeof row.value === "object") {
                vendorData.doorNumber = row.value.doorNo || "";
                vendorData.addressLine = row.value.street || "";
                vendorData.city = row.value.city || "";
                vendorData.state = row.value.state || "";
                vendorData.pincode = row.value.pincode || "";
                vendorData.landMark = row.value.landmark || "";
                vendorData.latitude = row.value.latitude ? parseFloat(row.value.latitude) : null;
                vendorData.longitude = row.value.longitude ? parseFloat(row.value.longitude) : null;
            }

            if (row.key === "Bank Details" && typeof row.value === "object") {
                vendorData.holderName = row.value.holderName || "";
                vendorData.branchName = row.value.branchName || "";
                vendorData.accountNumber = row.value.accountNumber || "";
                vendorData.ifscCode = row.value.ifscCode || "";
            }

            if (row.key === "Trade License" && typeof row.value === "object") {
                vendorData.tradeLicenseStartDate = row.value.startDate || "";
                vendorData.tradeLicenseEndDate = row.value.endDate || "";
            }

            if (row.key === "FSSI License" && typeof row.value === "object") {
                vendorData.fssaiStartDate = row.value.startDate || "";
                vendorData.fssaiEndDate = row.value.endDate || "";
            }

            if (row.key === "Labour License" && typeof row.value === "object") {
                vendorData.labourStartDate = row.value.startDate || "";
                vendorData.labourEndDate = row.value.endDate || "";
            }

            formData.append("vendorData", new Blob([JSON.stringify(vendorData)], { type: "application/json" }));

            if (row.images?.length > 0) {
                row.images.forEach((img, idx) => {
                    if (img.file) {
                        const imageFieldName = getImageFieldName(row.key, idx);
                        formData.append(imageFieldName, img.file);
                    }
                });
            }

            const response = await updateVendorDetails(vendorId, formData, token);
            alert("Data updated successfully!");

            setRows((prev) =>
                prev.map((r, idx) =>
                    idx === rowIndex ? { ...r, isEditing: false } : r
                )
            );

            await fetchVendorDetails(vendorId);

        } catch (err) {
            console.error("Full Update Error:", err);
            alert(err.response?.data?.message || err.message || "Failed to update vendor");
        }
    };

    const getImageFieldName = (rowKey, imageIndex) => {
        const fieldMap = {
            "Register Documents": imageIndex === 0 ? "registeredDocumentsFront" : "registeredDocumentsBack",
            "AADHAR CARD NO": imageIndex === 0 ? "aadharPhotoFront" : "aadharPhotoBack",
            "PAN CARD NO": "panCard",
            "Trade License": "tradeLicense",
            "FSSI License": "fssaiLicense",
            "Labour License": "labourLicense",
            "Bank Details": "blankCheque",
            "Passbook": "passbook",
            "Company Name": "companyLogo",
        };
        return fieldMap[rowKey] || `image${imageIndex + 1}`;
    };

    const handleVerifyy = async (i) => {
        const normalisedKey = rows[i].key.trim().replace(/\.$/, "");
        const statusField = STATUS_FIELD_MAP[normalisedKey];

        if (!statusField) {
            console.warn("No status mapping for:", rows[i].key);
            return;
        }

        const vendorId = getCurrentVendorId();
        if (!vendorId) {
            alert("Vendor ID is missing");
            return;
        }

        if (vendorNotFound) {
            alert("Vendor not registered. Cannot verify.");
            return;
        }

        const token = localStorage.getItem("authToken");
        if (!token) {
            alert("Authorization token missing");
            return;
        }

        try {
            const vendorData = {
                ownerNameStatus: vendorDetails?.ownerNameStatus ?? false,
                businessPlanStatus: vendorDetails?.businessPlanStatus ?? false,
                registeredNameStatus: vendorDetails?.registeredNameStatus ?? false,
                registeredDocumentsStatus: vendorDetails?.registeredDocumentsStatus ?? false,
                mobileNumberStatus: vendorDetails?.mobileNumberStatus ?? false,
                emailStatus: vendorDetails?.emailStatus ?? false,
                aadharNumberStatus: vendorDetails?.aadharNumberStatus ?? false,
                panCardStatus: vendorDetails?.panCardStatus ?? false,
                websiteNameStatus: vendorDetails?.websiteNameStatus ?? false,
                gstNumberStatus: vendorDetails?.gstNumberStatus ?? false,
                tradeLicenseStatus: vendorDetails?.tradeLicenseStatus ?? false,
                fssaiLicenseStatus: vendorDetails?.fssaiLicenseStatus ?? false,
                labourLicenseStatus: vendorDetails?.labourLicenseStatus ?? false,
                blankChequeStatus: vendorDetails?.blankChequeStatus ?? false,
                passbookStatus: vendorDetails?.passbookStatus ?? false,
                addressStatus: vendorDetails?.addressStatus ?? false,
                orderTypeStatus: vendorDetails?.orderTypeStatus ?? false,
                businessVerticalStatus: vendorDetails?.businessVerticalStatus ?? false,
                ratingStatus: vendorDetails?.ratingStatus ?? false,
                [statusField]: true,
            };

            setVendorDetails((prev) => ({
                ...prev,
                [statusField]: true,
            }));

            await verifyVendorStatus(vendorId, vendorData, token);
            await fetchVendorDetails(vendorId);
            alert("Vendor data verified successfully!");

        } catch (err) {
            console.error("❌ Verify error:", err);
            setVendorDetails((prev) => ({
                ...prev,
                [statusField]: false,
            }));

            if (err.response?.status === 500 && err.response?.data?.message === "vendorId not found") {
                alert("Vendor not registered. Cannot verify.");
            } else if (err.response?.status === 404) {
                alert("Vendor not registered. Cannot verify.");
            } else {
                alert(`Failed to update status: ${err.response?.data?.message || err.message}`);
            }
        }
    };

    const handleReject = async (i) => {
        const normalisedKey = rows[i].key.trim().replace(/\.$/, "");
        const statusField = STATUS_FIELD_MAP[normalisedKey];

        if (!statusField) {
            console.warn("No status mapping for:", rows[i].key);
            return;
        }

        const vendorId = getCurrentVendorId();
        if (!vendorId) {
            alert("Vendor ID is missing – cannot update.");
            return;
        }

        if (vendorNotFound) {
            alert("Vendor not registered. Cannot reject.");
            return;
        }

        const token = localStorage.getItem("authToken");
        if (!token) {
            alert("Authorization token missing. Please log in.");
            return;
        }

        try {
            const vendorData = {
                ownerNameStatus: vendorDetails?.ownerNameStatus ?? false,
                businessPlanStatus: vendorDetails?.businessPlanStatus ?? false,
                registeredNameStatus: vendorDetails?.registeredNameStatus ?? false,
                registeredDocumentsStatus: vendorDetails?.registeredDocumentsStatus ?? false,
                mobileNumberStatus: vendorDetails?.mobileNumberStatus ?? false,
                emailStatus: vendorDetails?.emailStatus ?? false,
                aadharNumberStatus: vendorDetails?.aadharNumberStatus ?? false,
                panCardStatus: vendorDetails?.panCardStatus ?? false,
                websiteNameStatus: vendorDetails?.websiteNameStatus ?? false,
                gstNumberStatus: vendorDetails?.gstNumberStatus ?? false,
                tradeLicenseStatus: vendorDetails?.tradeLicenseStatus ?? false,
                fssaiLicenseStatus: vendorDetails?.fssaiLicenseStatus ?? false,
                labourLicenseStatus: vendorDetails?.labourLicenseStatus ?? false,
                blankChequeStatus: vendorDetails?.blankChequeStatus ?? false,
                passbookStatus: vendorDetails?.passbookStatus ?? false,
                addressStatus: vendorDetails?.addressStatus ?? false,
                orderTypeStatus: vendorDetails?.orderTypeStatus ?? false,
                businessVerticalStatus: vendorDetails?.businessVerticalStatus ?? false,
                ratingStatus: vendorDetails?.ratingStatus ?? false,
                [statusField]: false,
            };

            setVendorDetails((prev) => ({
                ...prev,
                [statusField]: false,
            }));

            await verifyVendorStatus(vendorId, vendorData, token);
            await fetchVendorDetails(vendorId);
            alert("Vendor status rejected successfully!");

        } catch (err) {
            console.error("❌ Reject error:", err);
            setVendorDetails((prev) => ({
                ...prev,
                [statusField]: true,
            }));

            if (err.response?.status === 500 && err.response?.data?.message === "vendorId not found") {
                alert("Vendor not registered. Cannot reject.");
            } else if (err.response?.status === 404) {
                alert("Vendor not registered. Cannot reject.");
            } else {
                alert(`Failed to reject status: ${err.response?.data?.message || err.message}`);
            }
        }
    };

    // Fetch subscriptions from new API endpoint
    useEffect(() => {
        const token = localStorage.getItem("authToken");

        const fetchData = async () => {
            showLoader();

            try {
                const data = await getAllEnquiries(token);
                const subscriptions = Array.isArray(data) ? data : [];

                const filtered = subscriptions.filter(
                    (item) =>
                        item.businessVerticals &&
                        item.businessVerticals.includes("FOOD_AND_BEVERAGES") &&
                        (item.parentId === null || item.parentId === 0 || item.parentId === undefined)
                );

                setRolesData(filtered);
                setFilteredData(filtered);

                if (filtered.length > 0) {
                    const vendor = filtered[0];
                    const vendorId = vendor?.vendorId;
                    const parentId = vendor?.parentId;

                    if (vendorId && (parentId === null || parentId === 0 || parentId === undefined)) {
                        fetchVendorDetails(vendorId);
                    }
                }

            } catch (err) {
                console.error("Payment fetch error:", err);
            } finally {
                hideLoader();
            }
        };

        fetchData();
    }, []);

    // Apply filters
    useEffect(() => {
        let result = rolesData;

        if (cityFilter) {
            result = result.filter(item => item.city === cityFilter);
        }

        if (businessVerticalFilter) {
            result = result.filter(item => item.businessVertical === businessVerticalFilter);
        }

        if (searchQuery.trim()) {
            const query = searchQuery.toLowerCase().trim();
            result = result.filter(item => {
                let fieldValue;

                if (searchType === "vendorId") {
                    fieldValue = item.vendorId;
                } else if (searchType === "phoneNumber") {
                    fieldValue = item.customerMobile;
                } else if (searchType === "email") {
                    fieldValue = item.email || item.customerEmail;
                } else if (searchType === "name") {
                    fieldValue = item.customerName;
                } else if (searchType === "city") {
                    fieldValue = item.city;
                } else if (searchType === "businessVertical") {
                    fieldValue = item.businessVertical;
                } else {
                    fieldValue = item[searchType];
                }

                if (!fieldValue) return false;

                if (searchType === "phoneNumber") {
                    const cleanPartnerMobile = fieldValue.toString().replace(/\D/g, '');
                    const cleanQuery = query.replace(/\D/g, '');
                    return fieldValue.toString().toLowerCase().includes(query) ||
                        cleanPartnerMobile.includes(cleanQuery);
                }

                return fieldValue.toString().toLowerCase().includes(query);
            });
        }

        setFilteredData(result);
    }, [rolesData, cityFilter, businessVerticalFilter, searchType, searchQuery]);

    const uniqueCities = useMemo(() => {
        const cities = rolesData.map(item => item.city).filter(Boolean);
        return [...new Set(cities)].sort();
    }, [rolesData]);

    const uniqueBusinessVerticals = useMemo(() => {
        const verticals = rolesData.map(item => item.businessVertical).filter(Boolean);
        return [...new Set(verticals)].sort();
    }, [rolesData]);

    const clearAllFilters = () => {
        setSearchQuery("");
        setCityFilter("");
        setBusinessVerticalFilter("");
        setSearchType("vendorId");
    };

    const getPlaceholderText = () => {
        switch (searchType) {
            case "vendorId": return "Search by Vendor ID...";
            case "name": return "Search by Customer Name...";
            case "email": return "Search by Email...";
            case "phoneNumber": return "Search by Mobile...";
            case "city": return "Search by City...";
            case "businessVertical": return "Search by Business Vertical...";
            default: return "Search...";
        }
    };

    const searchOptions = [
        { value: "vendorId", label: "Vendor ID" },
        { value: "name", label: "Customer Name" },
        { value: "createdAt", label: "Date" },
        { value: "email", label: "Email" },
        { value: "phoneNumber", label: "Mobile Number" },
        { value: "city", label: "City" },
        { value: "businessVertical", label: "Business Vertical" }
    ];

    useEffect(() => {
        if (!selectedClient) {
            setRows(getDefaultClientDetailsRows());
            setVerifiedRows([]);
            setRejectedRows([]);
            setIsApproved(false);
            setImageLoadErrors(new Set());
            return;
        }

        const merged = { ...selectedClient, ...(vendorDetails || {}) };

        const imageMap = {
            "Register Documents": [
                normalizeImageUrl(merged.registeredDocumentsFront),
                normalizeImageUrl(merged.registeredDocumentsBack)
            ].filter(url => url),
            "AADHAR CARD NO": [
                normalizeImageUrl(merged.aadharPhotoFront),
                normalizeImageUrl(merged.aadharPhotoBack)
            ].filter(url => url),
            "PAN CARD NO": [normalizeImageUrl(merged.panCard)].filter(url => url),
            "Trade License": [normalizeImageUrl(merged.tradeLicense)].filter(url => url),
            "FSSI License": [normalizeImageUrl(merged.fssaiLicense)].filter(url => url),
            "Labour License": [normalizeImageUrl(merged.labourLicense)].filter(url => url),
            "Bank Details": [normalizeImageUrl(merged.blankCheque)].filter(url => url),
            "Passbook": [normalizeImageUrl(merged.passbook)].filter(url => url),
            "Company Name": [normalizeImageUrl(merged.companyLogo)].filter(url => url),
        };

        const newRows = [
            { key: "Owner Name", value: merged.ownerName || "N/A" },
            { key: "Company Name", value: merged.registeredName || "N/A" },
            { key: "Business Plan", value: merged.businessPlan || "N/A" },
            { key: "Position", value: merged.position || "N/A" },
            { key: "Branding", value: merged.brandName || "N/A" },
            { key: "Business Vertical", value: merged.businessVertical || "N/A" },
            {
                key: "Order Type",
                value: Array.isArray(merged.orderTypes)
                    ? merged.orderTypes
                    : typeof merged.orderTypes === "string" && merged.orderTypes !== "N/A"
                        ? merged.orderTypes.split(",").map(v => v.trim())
                        : [],
            },
            { key: "Website", value: merged.websiteName || "N/A" },
            { key: "Phone No", value: merged.mobileNumber || merged.customerMobile || "N/A" },
            { key: "Email ID", value: merged.email || merged.customerEmail || "N/A" },
            { key: "City", value: merged.city || "N/A" },
            {
                key: "Address",
                value: {
                    doorNo: merged.doorNumber || "N/A",
                    street: merged.addressLine || "N/A",
                    city: merged.city || "N/A",
                    state: merged.state || "N/A",
                    pincode: merged.pincode || "N/A",
                    landmark: merged.landMark || "N/A",
                    latitude: merged.latitude?.toString() || "N/A",
                    longitude: merged.longitude?.toString() || "N/A",
                },
            },
            { key: "Register Documents", value: "Registered Documents" },
            { key: "AADHAR CARD NO", value: merged.aadharNumber || "N/A" },
            { key: "PAN CARD NO", value: merged.panCardNumber || "N/A" },
            { key: "Trade License Number", value: merged.tradeLicenseNumber || "N/A" },
            {
                key: "Trade License",
                value: {
                    startDate: merged.tradeLicenseStartDate || "N/A",
                    endDate: merged.tradeLicenseEndDate || "N/A",
                },
            },
            { key: "FSSAI License Number", value: merged.fssaiLicenseNumber || "N/A" },
            {
                key: "FSSI License",
                value: {
                    startDate: merged.fssaiStartDate || "N/A",
                    endDate: merged.fssaiEndDate || "N/A",
                },
            },
            { key: "Labour License Number", value: merged.labourLicenseNumber || "N/A" },
            {
                key: "Labour License",
                value: {
                    startDate: merged.labourStartDate || "N/A",
                    endDate: merged.labourEndDate || "N/A",
                },
            },
            { key: "GST No.", value: merged.gstNumber || "N/A" },
            {
                key: "Bank Details",
                value: {
                    holderName: merged.holderName || merged.accountHolderName || "N/A",
                    branchName: merged.branchName || merged.bankName || "N/A",
                    accountNumber: merged.accountNumber || merged.accountNo || "N/A",
                    ifscCode: merged.ifscCode || "N/A",
                },
            },
            { key: "Passbook", value: "Passbook Image" },
            { key: "Rating", value: merged.rating || 0 },
            { key: "Selected Modules", value: merged.selectedModules?.join(", ") || "N/A" },
            { key: "Remaining Days", value: merged.remainingDays ? `${merged.remainingDays} days` : "N/A" },
        ];

        const updatedRows = newRows.map((row) => ({
            ...row,
            images: imageMap[row.key] || [],
        }));

        setRows(updatedRows.map((r) => ({ ...r, isEditing: false })));
        setVerifiedRows([]);
        setRejectedRows([]);
        setIsApproved(false);
        setImageLoadErrors(new Set());
    }, [selectedClient, vendorDetails]);

    const handleViewClick = (client) => {
        setSelectedClient(client);
        const vendorId = client?.vendorId;
        setVendorNotFound(false);
        setVendorError(null);
        fetchVendorDetails(vendorId);
    };

    const handleBackClick = () => {
        setSelectedClient(null);
        setVendorNotFound(false);
        setVendorError(null);
    };

    const handleFileChange = (e, index) => {
        const fileName = e.target.files[0]?.name || "";
        const updated = [...rows];
        updated[index].value = fileName;
        setRows(updated);
    };

    // Clean Image Display Component
    const ImageDisplay = ({ images, fieldName }) => {
        if (!images || images.length === 0) {
            return (
                <div className="text-center">
                    <span style={{ fontSize: "18px", color: "#6c757d" }}>—</span>
                </div>
            );
        }

        return (
            <div className="d-flex justify-content-center gap-2 flex-wrap">
                {images.map((img, idx) => {
                    const imageUrl = typeof img === 'string' ? img : img.url;
                    const hasFailed = isImageFailed(fieldName, idx);

                    if (hasFailed || !imageUrl) {
                        return (
                            <div key={idx} className="text-center">
                                <span style={{ fontSize: "18px", color: "#6c757d" }}>—</span>
                            </div>
                        );
                    }

                    return (
                        <div key={idx} className="text-center position-relative">
                            <img
                                src={imageUrl}
                                alt={`${fieldName}-${idx}`}
                                style={{
                                    width: fieldName === "Company Name" ? "80px" : "60px",
                                    height: fieldName === "Company Name" ? "80px" : "60px",
                                    borderRadius: "8px",
                                    objectFit: "cover",
                                    border: "2px solid #e2e8f0",
                                    transition: "transform 0.2s ease"
                                }}
                                onError={() => handleImageError(imageUrl, fieldName, idx)}
                                onLoad={() => handleImageLoad(imageUrl, fieldName, idx)}
                            />
                        </div>
                    );
                })}
            </div>
        );
    };

    return (
        <div style={styles.container}>
            {!selectedClient ? (
                <>
                    {/* Filters */}
                    <div style={styles.filtersContainer}>
                        <div style={styles.searchGroup}>
                            <select
                                value={searchType}
                                onChange={(e) => setSearchType(e.target.value)}
                                style={styles.select}
                            >
                                {searchOptions.map(option => (
                                    <option key={option.value} value={option.value}>
                                        {option.label}
                                    </option>
                                ))}
                            </select>

                            <input
                                type="text"
                                placeholder={getPlaceholderText()}
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                                style={{
                                    ...styles.input,
                                    borderColor: searchQuery ? 'rgb(230 109 51)' : '#e2e8f0'
                                }}
                            />
                        </div>

                        <select
                            value={cityFilter}
                            onChange={(e) => setCityFilter(e.target.value)}
                            style={{ ...styles.select, minWidth: '110px' }}
                        >
                            <option value="">All Cities</option>
                            {uniqueCities.map(city => (
                                <option key={city} value={city}>{city}</option>
                            ))}
                        </select>

                        <button
                            onClick={clearAllFilters}
                            style={{ ...styles.button, ...styles.buttonSecondary }}
                        >
                            <Icons.Clear /> Clear
                        </button>

                        {(searchQuery || cityFilter || businessVerticalFilter) && (
                            <span style={{ fontSize: '12px', color: '#718096' }}>
                                <strong>{filteredData.length}</strong> result{filteredData.length !== 1 && 's'}
                            </span>
                        )}
                    </div>

                    {/* Table */}
                    <div style={styles.tableWrapper}>
                        <table style={styles.table}>
                            <thead style={styles.thead}>
                                <tr>
                                    <th style={{ ...styles.th, width: '50px', textAlign: 'center' }}>#</th>
                                    <th style={styles.th}>Date</th>
                                    <th style={styles.th}>Customer</th>
                                    <th style={styles.th}>Restaurant</th>
                                    <th style={styles.th}>Email</th>
                                    <th style={styles.th}>Mobile</th>
                                    <th style={styles.th}>City</th>
                                    <th style={styles.th}>Vendor ID</th>
                                    {/* <th style={styles.th}>Status</th> */}
                                    <th style={{ ...styles.th, textAlign: 'center', width: '80px' }}>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredData.length ? (
                                    filteredData.map((c, idx) => {
                                        // Determine approval status - check both approvalStatus and isApproved
                                        const isApproved = c.approvalStatus === true || c.isApproved === true;

                                        return (
                                            <tr
                                                key={c.subscriptionId || idx}
                                                style={{
                                                    backgroundColor: idx % 2 === 0 ? '#ffffff' : '#fafbfc',
                                                    transition: 'background 0.15s ease'
                                                }}
                                                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f0f4ff'}
                                                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = idx % 2 === 0 ? '#ffffff' : '#fafbfc'}
                                            >
                                                <td style={{ ...styles.td, textAlign: 'center', color: '#a0aec0' }}>{idx + 1}</td>
                                                <td style={styles.td}>{formatDate(c?.registerTime)}</td>
                                                <td style={{ ...styles.td, fontWeight: '500' }}>{c?.name || "—"}</td>
                                                <td style={styles.td}>{c?.registeredName || c?.companyName || "—"}</td>
                                                <td style={{ ...styles.td, color: '#4a5568' }}>{c?.email || c?.customerEmail || "—"}</td>
                                                <td style={styles.td}>{c?.mobileNumber || "—"}</td>
                                                <td style={styles.td}>{c?.city || "—"}</td>
                                                <td style={styles.td}>{c?.vendorId || "—"}</td>
                                                {/* <td style={styles.td}>
                                                    {isApproved ? (
                                                        <span style={{ ...styles.statusBadge, ...styles.approvedBadge }}>
                                                            <Icons.Approved /> Approved
                                                        </span>
                                                    ) : (
                                                        <span style={{ ...styles.statusBadge, ...styles.pendingStatusBadge }}>
                                                            <Icons.Pending /> Pending
                                                        </span>
                                                    )}
                                                </td> */}
                                                <td style={{ ...styles.td, textAlign: 'center' }}>
                                                    <button
                                                        style={{
                                                            ...styles.button,
                                                            ...styles.buttonPrimary,
                                                            padding: '4px 14px',
                                                            height: '32px',
                                                            fontSize: '12px'
                                                        }}
                                                        onClick={() => handleViewClick(c)}
                                                    >
                                                        View
                                                    </button>
                                                </td>
                                            </tr>
                                        );
                                    })
                                ) : (
                                    <tr>
                                        <td colSpan="10" style={{ padding: 0 }}>
                                            <div style={styles.emptyState}>
                                                <div style={{ fontSize: '40px', opacity: 0.5 }}>📋</div>
                                                <div style={styles.emptyStateText}>
                                                    {rolesData.length === 0 ? 'Loading vendors...' : 'No vendors found'}
                                                </div>
                                                <div style={styles.emptyStateSubtext}>
                                                    {rolesData.length === 0
                                                        ? 'Please wait while we fetch the data'
                                                        : (searchQuery.trim() || cityFilter || businessVerticalFilter)
                                                            ? 'Try adjusting your filters to see more results'
                                                            : 'No paid food vendors are available'}
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </>
            ) : (
                /* ============ DETAIL VIEW ============ */
                <div>
                    {/* Detail Header */}
                    <div style={styles.detailHeader}>
                        <button
                            onClick={handleBackClick}
                            style={{ ...styles.button, ...styles.buttonPrimary }}
                        >
                            <Icons.Back /> Back
                        </button>
                        <div style={styles.detailTitle}>
                            Vendor Details — <span style={{ color: 'rgb(230 109 51)' }}>
                                {selectedClient?.registeredName || selectedClient?.name || 'N/A'}
                            </span>
                        </div>
                        {vendorDetails?.approvalStatus ? (
                            <span style={{ ...styles.statusBadge, ...styles.verifiedBadge }}>
                                <Icons.Approved /> Approved
                            </span>
                        ) : (
                            <button
                                style={{ ...styles.button, ...styles.buttonSuccess }}
                                onClick={handleApproveAll}
                            >
                                <Icons.Check /> Approve
                            </button>
                        )}
                    </div>

                    {loading && (
                        <div className="text-center my-5">
                            <div className="spinner-border text-primary" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    )}

                    {!loading && vendorNotFound && (
                        <div style={styles.emptyState}>
                            <div style={{ fontSize: '48px' }}>⚠️</div>
                            <div style={{ ...styles.emptyStateText, color: '#dc3545' }}>
                                Vendor Not Registered
                            </div>
                            <div style={styles.emptyStateSubtext}>
                                This vendor has a subscription but is not registered in the system.
                                <br />
                                Vendor ID: <strong>{selectedClient?.vendorId}</strong>
                            </div>
                        </div>
                    )}

                    {!loading && !vendorNotFound && vendorDetails && (
                        <div style={styles.detailTableWrapper}>
                            <table style={styles.detailTable}>
                                <thead>
                                    <tr>
                                        <th style={styles.detailTh}>Field</th>
                                        <th style={styles.detailTh}>Value</th>
                                        <th style={styles.detailTh}>Image</th>
                                        <th style={styles.detailTh}>Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {rows.map((r, i) => {
                                        const isEditing = r.isEditing || false;

                                        const handleInputChange = (field, value) => {
                                            setRows((prevRows) =>
                                                prevRows.map((row, idx) =>
                                                    idx === i
                                                        ? {
                                                            ...row,
                                                            value:
                                                                typeof row.value === "object"
                                                                    ? { ...row.value, [field]: value }
                                                                    : value,
                                                        }
                                                        : row
                                                )
                                            );
                                        };

                                        const handleOrderTypeChange = (selectedValue) => {
                                            setRows((prevRows) =>
                                                prevRows.map((row, idx) => {
                                                    if (idx === i) {
                                                        const currentValues = Array.isArray(row.value) ? row.value : [];
                                                        const isSelected = currentValues.includes(selectedValue);

                                                        if (isSelected) {
                                                            return {
                                                                ...row,
                                                                value: currentValues.filter(v => v !== selectedValue)
                                                            };
                                                        } else {
                                                            return {
                                                                ...row,
                                                                value: [...currentValues, selectedValue]
                                                            };
                                                        }
                                                    }
                                                    return row;
                                                })
                                            );
                                        };

                                        const handleBusinessPlanChange = (selectedValue) => {
                                            setRows((prevRows) =>
                                                prevRows.map((row, idx) =>
                                                    idx === i
                                                        ? { ...row, value: selectedValue }
                                                        : row
                                                )
                                            );
                                        };

                                        const handleRatingChange = (selectedValue) => {
                                            setRows((prevRows) =>
                                                prevRows.map((row, idx) =>
                                                    idx === i
                                                        ? { ...row, value: parseFloat(selectedValue) }
                                                        : row
                                                )
                                            );
                                        };

                                        const handleImageChange = (e) => {
                                            const files = Array.from(e.target.files);
                                            const newImages = files.map((file) => ({
                                                url: URL.createObjectURL(file),
                                                file
                                            }));

                                            setRows(prev =>
                                                prev.map((row, idx) =>
                                                    idx === i
                                                        ? { ...row, images: [...(row.images || []), ...newImages] }
                                                        : row
                                                )
                                            );
                                        };

                                        const isEditableField = ![
                                            "Selected Modules",
                                            "Remaining Days",
                                            "Business Vertical",
                                            "City"
                                        ].includes(r.key);

                                        return (
                                            <tr key={r.key || i}>
                                                <td style={{ ...styles.detailTd, fontWeight: '600' }}>{r.key}</td>

                                                <td style={styles.detailTd}>
                                                    {r.key === "Order Type" ? (
                                                        isEditing ? (
                                                            <div className="d-flex flex-column gap-1">
                                                                {orderTypeOptions.map((option) => {
                                                                    const currentValues = Array.isArray(r.value) ? r.value : [];
                                                                    const isSelected = currentValues.includes(option);
                                                                    return (
                                                                        <div key={option} className="form-check">
                                                                            <input
                                                                                className="form-check-input"
                                                                                type="checkbox"
                                                                                id={`order-type-${option}-${i}`}
                                                                                checked={isSelected}
                                                                                onChange={() => handleOrderTypeChange(option)}
                                                                            />
                                                                            <label className="form-check-label" htmlFor={`order-type-${option}-${i}`}>
                                                                                {option}
                                                                            </label>
                                                                        </div>
                                                                    );
                                                                })}
                                                            </div>
                                                        ) : (
                                                            Array.isArray(r.value) && r.value.length > 0
                                                                ? r.value.join(", ")
                                                                : "N/A"
                                                        )
                                                    ) : r.key === "Business Plan" ? (
                                                        isEditing && isEditableField ? (
                                                            <select
                                                                value={r.value || ""}
                                                                onChange={(e) => handleBusinessPlanChange(e.target.value)}
                                                                className="form-select"
                                                            >
                                                                <option value="">Select Business Plan</option>
                                                                {businessPlanOptions.map((option) => (
                                                                    <option key={option} value={option}>{option}</option>
                                                                ))}
                                                            </select>
                                                        ) : (
                                                            r.value || "N/A"
                                                        )
                                                    ) : r.key === "Rating" ? (
                                                        isEditing && isEditableField ? (
                                                            <select
                                                                value={r.value || 0}
                                                                onChange={(e) => handleRatingChange(e.target.value)}
                                                                className="form-select"
                                                            >
                                                                {ratingOptions.map((option) => (
                                                                    <option key={option.value} value={option.value}>
                                                                        {option.label}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        ) : (
                                                            <div>{r.value || 0} {r.value ? "★" : ""}</div>
                                                        )
                                                    ) : r.key === "Company Name" ? (
                                                        <div>
                                                            {isEditing && isEditableField ? (
                                                                <input
                                                                    type="text"
                                                                    value={r.value || ""}
                                                                    onChange={(e) => handleInputChange("value", e.target.value)}
                                                                    className="form-control mb-1"
                                                                />
                                                            ) : (
                                                                r.value || "N/A"
                                                            )}
                                                        </div>
                                                    ) : r.key === "Bank Details" ? (
                                                        ["holderName", "branchName", "accountNumber", "ifscCode"].map((field) => (
                                                            <div key={field} className="mb-1">
                                                                <strong>{field.replace(/([A-Z])/g, " $1")}:</strong>{" "}
                                                                {isEditing && isEditableField ? (
                                                                    <input
                                                                        type="text"
                                                                        value={r.value?.[field] || ""}
                                                                        onChange={(e) => handleInputChange(field, e.target.value)}
                                                                        className="form-control d-inline-block w-75"
                                                                    />
                                                                ) : (
                                                                    r.value?.[field] || "N/A"
                                                                )}
                                                            </div>
                                                        ))
                                                    ) : r.key === "Address" ? (
                                                        ["doorNo", "street", "city", "state", "pincode", "landmark", "latitude", "longitude"].map((field) => (
                                                            <div key={field} className="mb-1">
                                                                <strong>{field.charAt(0).toUpperCase() + field.slice(1)}:</strong>{" "}
                                                                {isEditing && isEditableField ? (
                                                                    <input
                                                                        type="text"
                                                                        value={r.value?.[field] || ""}
                                                                        onChange={(e) => handleInputChange(field, e.target.value)}
                                                                        className="form-control d-inline-block w-75"
                                                                    />
                                                                ) : (
                                                                    r.value?.[field] || "N/A"
                                                                )}
                                                            </div>
                                                        ))
                                                    ) : r.key === "Trade License" ||
                                                        r.key === "FSSI License" ||
                                                        r.key === "Labour License" ? (
                                                        <>
                                                            <div className="mb-1">
                                                                <strong>Start Date:</strong>{" "}
                                                                {isEditing && isEditableField ? (
                                                                    <input
                                                                        type="date"
                                                                        value={safeDateToISOString(r.value?.startDate)}
                                                                        onChange={(e) => handleInputChange("startDate", e.target.value)}
                                                                        className="form-control d-inline-block w-75"
                                                                    />
                                                                ) : (
                                                                    safeDateDisplay(r.value?.startDate)
                                                                )}
                                                            </div>
                                                            <div>
                                                                <strong>End Date:</strong>{" "}
                                                                {isEditing && isEditableField ? (
                                                                    <input
                                                                        type="date"
                                                                        value={safeDateToISOString(r.value?.endDate)}
                                                                        onChange={(e) => handleInputChange("endDate", e.target.value)}
                                                                        className="form-control d-inline-block w-75"
                                                                    />
                                                                ) : (
                                                                    safeDateDisplay(r.value?.endDate)
                                                                )}
                                                            </div>
                                                        </>
                                                    ) : r.key === "Trade License Number" ||
                                                        r.key === "Labour License Number" ||
                                                        r.key === "FSSAI License Number" ||
                                                        r.key === "Owner Name" ||
                                                        r.key === "Position" ||
                                                        r.key === "BrandName" ||
                                                        r.key === "Phone No" ||
                                                        r.key === "Email ID" ||
                                                        r.key === "Website" ||
                                                        r.key === "GST No." ||
                                                        r.key === "AADHAR CARD NO" ||
                                                        r.key === "PAN CARD NO" ? (
                                                        isEditing && isEditableField ? (
                                                            <input
                                                                type="text"
                                                                value={r.value || ""}
                                                                onChange={(e) => handleInputChange("value", e.target.value)}
                                                                className="form-control"
                                                            />
                                                        ) : (
                                                            r.value || "N/A"
                                                        )
                                                    ) : r.key === "Register Documents" ? (
                                                        "Registered Documents"
                                                    ) : r.key === "Passbook" ? (
                                                        "Passbook Image"
                                                    ) : (
                                                        r.value || "N/A"
                                                    )}
                                                </td>

                                                <td style={{ ...styles.detailTd, textAlign: 'center' }}>
                                                    {isEditing && isEditableField ? (
                                                        <>
                                                            {(r.key === "Company Name" || r.key === "Register Documents" ||
                                                                r.key === "AADHAR CARD NO" || r.key === "PAN CARD NO" ||
                                                                r.key === "Trade License" || r.key === "FSSI License" ||
                                                                r.key === "Labour License" || r.key === "Bank Details" ||
                                                                r.key === "Passbook") && (
                                                                    <input
                                                                        type="file"
                                                                        multiple={r.key === "Register Documents" || r.key === "AADHAR CARD NO"}
                                                                        accept="image/*"
                                                                        onChange={handleImageChange}
                                                                        className="form-control mb-2"
                                                                    />
                                                                )}
                                                            <ImageDisplay images={r.images} fieldName={r.key} />
                                                        </>
                                                    ) : (
                                                        <ImageDisplay images={r.images} fieldName={r.key} />
                                                    )}
                                                </td>

                                                <td style={{ ...styles.detailTd, textAlign: 'center' }}>
                                                    {isEditing && isEditableField ? (
                                                        <div className="d-flex flex-wrap gap-2 justify-content-center">
                                                            <button
                                                                className="btn btn-sm btn-success"
                                                                onClick={() => handleSaveRow(i)}
                                                                style={{ minWidth: 70 }}
                                                            >
                                                                <Icons.Save /> Save
                                                            </button>
                                                            <button
                                                                className="btn btn-sm btn-secondary"
                                                                onClick={() =>
                                                                    setRows((prev) =>
                                                                        prev.map((row, idx) =>
                                                                            idx === i ? { ...row, isEditing: false } : row
                                                                        )
                                                                    )
                                                                }
                                                                style={{ minWidth: 70 }}
                                                            >
                                                                Cancel
                                                            </button>
                                                        </div>
                                                    ) : (
                                                        <div className="d-flex flex-wrap gap-2 justify-content-center">
                                                            {isFieldVerified(r.key, r.value, vendorDetails, r.images) ? (
                                                                <span style={{ ...styles.statusBadge, ...styles.verifiedBadge }}>
                                                                    <Icons.Check /> Verified
                                                                </span>
                                                            ) : (
                                                                <button
                                                                    className="btn btn-sm btn-warning"
                                                                    onClick={() => handleVerifyy(i)}
                                                                    disabled={!canVerifyField(r.key, r.value, vendorDetails, r.images) || !isEditableField}
                                                                    style={{ minWidth: 70 }}
                                                                >
                                                                    Verify
                                                                </button>
                                                            )}

                                                            {isFieldRejected(r.key, vendorDetails) ? (
                                                                <span style={{ ...styles.statusBadge, ...styles.rejectedBadge }}>
                                                                    <Icons.X /> Rejected
                                                                </span>
                                                            ) : (
                                                                <button
                                                                    className="btn btn-sm btn-secondary"
                                                                    onClick={() => handleReject(i)}
                                                                    disabled={
                                                                        r.key === "Rating" ? true :
                                                                            !hasValidData({ key: r.key, value: r.value, images: r.images }, vendorDetails) ||
                                                                            !isEditableField
                                                                    }
                                                                    style={{ minWidth: 70 }}
                                                                >
                                                                    Reject
                                                                </button>
                                                            )}

                                                            {isEditableField && (
                                                                <button
                                                                    className="btn btn-sm btn-primary"
                                                                    onClick={() =>
                                                                        setRows((prev) =>
                                                                            prev.map((row, idx) =>
                                                                                idx === i ? { ...row, isEditing: true } : row
                                                                            )
                                                                        )
                                                                    }
                                                                    style={{ minWidth: 70 }}
                                                                >
                                                                    <Icons.Edit /> Edit
                                                                </button>
                                                            )}
                                                        </div>
                                                    )}
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default FoodPaidClents;